/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var extproto_ext_pb = require('./extproto/ext_pb.js');
var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js');
var github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb = require('./github.com/solo-io/dev-portal/api/dev-portal/v1beta1/common/common_pb.js');
var github_com_solo$io_dev$portal_api_dev$portal_v1beta1_apiproduct_pb = require('./github.com/solo-io/dev-portal/api/dev-portal/v1beta1/apiproduct_pb.js');
var github_com_solo$io_dev$portal_api_dev$portal_v1beta1_portal_pb = require('./github.com/solo-io/dev-portal/api/dev-portal/v1beta1/portal_pb.js');
var github_com_solo$io_dev$portal_api_grpc_common_common_pb = require('./github.com/solo-io/dev-portal/api/grpc/common/common_pb.js');
goog.exportSymbol('proto.app.portal.gloo.solo.io.APIProductDetails', null, global);
goog.exportSymbol('proto.app.portal.gloo.solo.io.APIProductListResponse', null, global);
goog.exportSymbol('proto.app.portal.gloo.solo.io.APIProductListSummary', null, global);
goog.exportSymbol('proto.app.portal.gloo.solo.io.APIProductPlanDetailsListResponse', null, global);
goog.exportSymbol('proto.app.portal.gloo.solo.io.APIProductPlanListSummary', null, global);
goog.exportSymbol('proto.app.portal.gloo.solo.io.APIProductPlansListResponse', null, global);
goog.exportSymbol('proto.app.portal.gloo.solo.io.APIProductSearchInfo', null, global);
goog.exportSymbol('proto.app.portal.gloo.solo.io.APIProductVersionDetails', null, global);
goog.exportSymbol('proto.app.portal.gloo.solo.io.APIProductVersionDetailsRequest', null, global);
goog.exportSymbol('proto.app.portal.gloo.solo.io.APIProductVersionSummary', null, global);
goog.exportSymbol('proto.app.portal.gloo.solo.io.AddAPIKeyRequest', null, global);
goog.exportSymbol('proto.app.portal.gloo.solo.io.AddAPIKeyResponse', null, global);
goog.exportSymbol('proto.app.portal.gloo.solo.io.ChangePasswordRequest', null, global);
goog.exportSymbol('proto.app.portal.gloo.solo.io.DynamicPage', null, global);
goog.exportSymbol('proto.app.portal.gloo.solo.io.EnvironmentPlans', null, global);
goog.exportSymbol('proto.app.portal.gloo.solo.io.EnvironmentVersionList', null, global);
goog.exportSymbol('proto.app.portal.gloo.solo.io.GRPCInvokeRequest', null, global);
goog.exportSymbol('proto.app.portal.gloo.solo.io.GRPCInvokeResponse', null, global);
goog.exportSymbol('proto.app.portal.gloo.solo.io.GetCurrentUserResponse', null, global);
goog.exportSymbol('proto.app.portal.gloo.solo.io.GetCustomStylingResponse', null, global);
goog.exportSymbol('proto.app.portal.gloo.solo.io.GetDynamicPagesResponse', null, global);
goog.exportSymbol('proto.app.portal.gloo.solo.io.GetPageExtensionsResponse', null, global);
goog.exportSymbol('proto.app.portal.gloo.solo.io.GetPortalSummaryResponse', null, global);
goog.exportSymbol('proto.app.portal.gloo.solo.io.GetStaticPagesResponse', null, global);
goog.exportSymbol('proto.app.portal.gloo.solo.io.LoginRequest', null, global);
goog.exportSymbol('proto.app.portal.gloo.solo.io.LoginRequest.BasicAuth', null, global);
goog.exportSymbol('proto.app.portal.gloo.solo.io.LoginResponse', null, global);
goog.exportSymbol('proto.app.portal.gloo.solo.io.PlanKey', null, global);
goog.exportSymbol('proto.app.portal.gloo.solo.io.PlanSummary', null, global);
goog.exportSymbol('proto.app.portal.gloo.solo.io.PlanSummary.AuthPolicyType', null, global);

/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.app.portal.gloo.solo.io.LoginRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.app.portal.gloo.solo.io.LoginRequest.oneofGroups_);
};
goog.inherits(proto.app.portal.gloo.solo.io.LoginRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.app.portal.gloo.solo.io.LoginRequest.displayName = 'proto.app.portal.gloo.solo.io.LoginRequest';
}
/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.app.portal.gloo.solo.io.LoginRequest.oneofGroups_ = [[1]];

/**
 * @enum {number}
 */
proto.app.portal.gloo.solo.io.LoginRequest.AuthMethodCase = {
  AUTH_METHOD_NOT_SET: 0,
  BASIC_AUTH: 1
};

/**
 * @return {proto.app.portal.gloo.solo.io.LoginRequest.AuthMethodCase}
 */
proto.app.portal.gloo.solo.io.LoginRequest.prototype.getAuthMethodCase = function() {
  return /** @type {proto.app.portal.gloo.solo.io.LoginRequest.AuthMethodCase} */(jspb.Message.computeOneofCase(this, proto.app.portal.gloo.solo.io.LoginRequest.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.app.portal.gloo.solo.io.LoginRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.app.portal.gloo.solo.io.LoginRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.app.portal.gloo.solo.io.LoginRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.app.portal.gloo.solo.io.LoginRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    basicAuth: (f = msg.getBasicAuth()) && proto.app.portal.gloo.solo.io.LoginRequest.BasicAuth.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.app.portal.gloo.solo.io.LoginRequest}
 */
proto.app.portal.gloo.solo.io.LoginRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.app.portal.gloo.solo.io.LoginRequest;
  return proto.app.portal.gloo.solo.io.LoginRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.app.portal.gloo.solo.io.LoginRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.app.portal.gloo.solo.io.LoginRequest}
 */
proto.app.portal.gloo.solo.io.LoginRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.app.portal.gloo.solo.io.LoginRequest.BasicAuth;
      reader.readMessage(value,proto.app.portal.gloo.solo.io.LoginRequest.BasicAuth.deserializeBinaryFromReader);
      msg.setBasicAuth(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.app.portal.gloo.solo.io.LoginRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.app.portal.gloo.solo.io.LoginRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.app.portal.gloo.solo.io.LoginRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.app.portal.gloo.solo.io.LoginRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBasicAuth();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.app.portal.gloo.solo.io.LoginRequest.BasicAuth.serializeBinaryToWriter
    );
  }
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.app.portal.gloo.solo.io.LoginRequest.BasicAuth = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.app.portal.gloo.solo.io.LoginRequest.BasicAuth, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.app.portal.gloo.solo.io.LoginRequest.BasicAuth.displayName = 'proto.app.portal.gloo.solo.io.LoginRequest.BasicAuth';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.app.portal.gloo.solo.io.LoginRequest.BasicAuth.prototype.toObject = function(opt_includeInstance) {
  return proto.app.portal.gloo.solo.io.LoginRequest.BasicAuth.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.app.portal.gloo.solo.io.LoginRequest.BasicAuth} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.app.portal.gloo.solo.io.LoginRequest.BasicAuth.toObject = function(includeInstance, msg) {
  var f, obj = {
    username: jspb.Message.getFieldWithDefault(msg, 1, ""),
    password: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.app.portal.gloo.solo.io.LoginRequest.BasicAuth}
 */
proto.app.portal.gloo.solo.io.LoginRequest.BasicAuth.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.app.portal.gloo.solo.io.LoginRequest.BasicAuth;
  return proto.app.portal.gloo.solo.io.LoginRequest.BasicAuth.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.app.portal.gloo.solo.io.LoginRequest.BasicAuth} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.app.portal.gloo.solo.io.LoginRequest.BasicAuth}
 */
proto.app.portal.gloo.solo.io.LoginRequest.BasicAuth.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUsername(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPassword(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.app.portal.gloo.solo.io.LoginRequest.BasicAuth.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.app.portal.gloo.solo.io.LoginRequest.BasicAuth.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.app.portal.gloo.solo.io.LoginRequest.BasicAuth} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.app.portal.gloo.solo.io.LoginRequest.BasicAuth.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUsername();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPassword();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string username = 1;
 * @return {string}
 */
proto.app.portal.gloo.solo.io.LoginRequest.BasicAuth.prototype.getUsername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.app.portal.gloo.solo.io.LoginRequest.BasicAuth.prototype.setUsername = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string password = 2;
 * @return {string}
 */
proto.app.portal.gloo.solo.io.LoginRequest.BasicAuth.prototype.getPassword = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.app.portal.gloo.solo.io.LoginRequest.BasicAuth.prototype.setPassword = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional BasicAuth basic_auth = 1;
 * @return {?proto.app.portal.gloo.solo.io.LoginRequest.BasicAuth}
 */
proto.app.portal.gloo.solo.io.LoginRequest.prototype.getBasicAuth = function() {
  return /** @type{?proto.app.portal.gloo.solo.io.LoginRequest.BasicAuth} */ (
    jspb.Message.getWrapperField(this, proto.app.portal.gloo.solo.io.LoginRequest.BasicAuth, 1));
};


/** @param {?proto.app.portal.gloo.solo.io.LoginRequest.BasicAuth|undefined} value */
proto.app.portal.gloo.solo.io.LoginRequest.prototype.setBasicAuth = function(value) {
  jspb.Message.setOneofWrapperField(this, 1, proto.app.portal.gloo.solo.io.LoginRequest.oneofGroups_[0], value);
};


proto.app.portal.gloo.solo.io.LoginRequest.prototype.clearBasicAuth = function() {
  this.setBasicAuth(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.app.portal.gloo.solo.io.LoginRequest.prototype.hasBasicAuth = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.app.portal.gloo.solo.io.LoginResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.app.portal.gloo.solo.io.LoginResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.app.portal.gloo.solo.io.LoginResponse.displayName = 'proto.app.portal.gloo.solo.io.LoginResponse';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.app.portal.gloo.solo.io.LoginResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.app.portal.gloo.solo.io.LoginResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.app.portal.gloo.solo.io.LoginResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.app.portal.gloo.solo.io.LoginResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    isFirstLogin: jspb.Message.getFieldWithDefault(msg, 2, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.app.portal.gloo.solo.io.LoginResponse}
 */
proto.app.portal.gloo.solo.io.LoginResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.app.portal.gloo.solo.io.LoginResponse;
  return proto.app.portal.gloo.solo.io.LoginResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.app.portal.gloo.solo.io.LoginResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.app.portal.gloo.solo.io.LoginResponse}
 */
proto.app.portal.gloo.solo.io.LoginResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsFirstLogin(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.app.portal.gloo.solo.io.LoginResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.app.portal.gloo.solo.io.LoginResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.app.portal.gloo.solo.io.LoginResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.app.portal.gloo.solo.io.LoginResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIsFirstLogin();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
};


/**
 * optional bool is_first_login = 2;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.app.portal.gloo.solo.io.LoginResponse.prototype.getIsFirstLogin = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 2, false));
};


/** @param {boolean} value */
proto.app.portal.gloo.solo.io.LoginResponse.prototype.setIsFirstLogin = function(value) {
  jspb.Message.setProto3BooleanField(this, 2, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.app.portal.gloo.solo.io.GetCurrentUserResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.app.portal.gloo.solo.io.GetCurrentUserResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.app.portal.gloo.solo.io.GetCurrentUserResponse.displayName = 'proto.app.portal.gloo.solo.io.GetCurrentUserResponse';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.app.portal.gloo.solo.io.GetCurrentUserResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.app.portal.gloo.solo.io.GetCurrentUserResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.app.portal.gloo.solo.io.GetCurrentUserResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.app.portal.gloo.solo.io.GetCurrentUserResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    username: jspb.Message.getFieldWithDefault(msg, 1, ""),
    publicAccessUser: jspb.Message.getFieldWithDefault(msg, 2, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.app.portal.gloo.solo.io.GetCurrentUserResponse}
 */
proto.app.portal.gloo.solo.io.GetCurrentUserResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.app.portal.gloo.solo.io.GetCurrentUserResponse;
  return proto.app.portal.gloo.solo.io.GetCurrentUserResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.app.portal.gloo.solo.io.GetCurrentUserResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.app.portal.gloo.solo.io.GetCurrentUserResponse}
 */
proto.app.portal.gloo.solo.io.GetCurrentUserResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUsername(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setPublicAccessUser(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.app.portal.gloo.solo.io.GetCurrentUserResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.app.portal.gloo.solo.io.GetCurrentUserResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.app.portal.gloo.solo.io.GetCurrentUserResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.app.portal.gloo.solo.io.GetCurrentUserResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUsername();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPublicAccessUser();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
};


/**
 * optional string username = 1;
 * @return {string}
 */
proto.app.portal.gloo.solo.io.GetCurrentUserResponse.prototype.getUsername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.app.portal.gloo.solo.io.GetCurrentUserResponse.prototype.setUsername = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool public_access_user = 2;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.app.portal.gloo.solo.io.GetCurrentUserResponse.prototype.getPublicAccessUser = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 2, false));
};


/** @param {boolean} value */
proto.app.portal.gloo.solo.io.GetCurrentUserResponse.prototype.setPublicAccessUser = function(value) {
  jspb.Message.setProto3BooleanField(this, 2, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.app.portal.gloo.solo.io.ChangePasswordRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.app.portal.gloo.solo.io.ChangePasswordRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.app.portal.gloo.solo.io.ChangePasswordRequest.displayName = 'proto.app.portal.gloo.solo.io.ChangePasswordRequest';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.app.portal.gloo.solo.io.ChangePasswordRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.app.portal.gloo.solo.io.ChangePasswordRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.app.portal.gloo.solo.io.ChangePasswordRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.app.portal.gloo.solo.io.ChangePasswordRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    currentPassword: jspb.Message.getFieldWithDefault(msg, 1, ""),
    newPassword: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.app.portal.gloo.solo.io.ChangePasswordRequest}
 */
proto.app.portal.gloo.solo.io.ChangePasswordRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.app.portal.gloo.solo.io.ChangePasswordRequest;
  return proto.app.portal.gloo.solo.io.ChangePasswordRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.app.portal.gloo.solo.io.ChangePasswordRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.app.portal.gloo.solo.io.ChangePasswordRequest}
 */
proto.app.portal.gloo.solo.io.ChangePasswordRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrentPassword(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setNewPassword(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.app.portal.gloo.solo.io.ChangePasswordRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.app.portal.gloo.solo.io.ChangePasswordRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.app.portal.gloo.solo.io.ChangePasswordRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.app.portal.gloo.solo.io.ChangePasswordRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCurrentPassword();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getNewPassword();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string current_password = 1;
 * @return {string}
 */
proto.app.portal.gloo.solo.io.ChangePasswordRequest.prototype.getCurrentPassword = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.app.portal.gloo.solo.io.ChangePasswordRequest.prototype.setCurrentPassword = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string new_password = 2;
 * @return {string}
 */
proto.app.portal.gloo.solo.io.ChangePasswordRequest.prototype.getNewPassword = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.app.portal.gloo.solo.io.ChangePasswordRequest.prototype.setNewPassword = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.app.portal.gloo.solo.io.APIProductListResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.app.portal.gloo.solo.io.APIProductListResponse.repeatedFields_, null);
};
goog.inherits(proto.app.portal.gloo.solo.io.APIProductListResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.app.portal.gloo.solo.io.APIProductListResponse.displayName = 'proto.app.portal.gloo.solo.io.APIProductListResponse';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.app.portal.gloo.solo.io.APIProductListResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.app.portal.gloo.solo.io.APIProductListResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.app.portal.gloo.solo.io.APIProductListResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.app.portal.gloo.solo.io.APIProductListResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.app.portal.gloo.solo.io.APIProductListResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    apiProductsList: jspb.Message.toObjectList(msg.getApiProductsList(),
    proto.app.portal.gloo.solo.io.APIProductListSummary.toObject, includeInstance),
    searchInfo: (f = msg.getSearchInfo()) && proto.app.portal.gloo.solo.io.APIProductSearchInfo.toObject(includeInstance, f),
    portalAllowAll: jspb.Message.getFieldWithDefault(msg, 3, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.app.portal.gloo.solo.io.APIProductListResponse}
 */
proto.app.portal.gloo.solo.io.APIProductListResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.app.portal.gloo.solo.io.APIProductListResponse;
  return proto.app.portal.gloo.solo.io.APIProductListResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.app.portal.gloo.solo.io.APIProductListResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.app.portal.gloo.solo.io.APIProductListResponse}
 */
proto.app.portal.gloo.solo.io.APIProductListResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.app.portal.gloo.solo.io.APIProductListSummary;
      reader.readMessage(value,proto.app.portal.gloo.solo.io.APIProductListSummary.deserializeBinaryFromReader);
      msg.addApiProducts(value);
      break;
    case 2:
      var value = new proto.app.portal.gloo.solo.io.APIProductSearchInfo;
      reader.readMessage(value,proto.app.portal.gloo.solo.io.APIProductSearchInfo.deserializeBinaryFromReader);
      msg.setSearchInfo(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setPortalAllowAll(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.app.portal.gloo.solo.io.APIProductListResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.app.portal.gloo.solo.io.APIProductListResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.app.portal.gloo.solo.io.APIProductListResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.app.portal.gloo.solo.io.APIProductListResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getApiProductsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.app.portal.gloo.solo.io.APIProductListSummary.serializeBinaryToWriter
    );
  }
  f = message.getSearchInfo();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.app.portal.gloo.solo.io.APIProductSearchInfo.serializeBinaryToWriter
    );
  }
  f = message.getPortalAllowAll();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
};


/**
 * repeated APIProductListSummary api_products = 1;
 * @return {!Array<!proto.app.portal.gloo.solo.io.APIProductListSummary>}
 */
proto.app.portal.gloo.solo.io.APIProductListResponse.prototype.getApiProductsList = function() {
  return /** @type{!Array<!proto.app.portal.gloo.solo.io.APIProductListSummary>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.app.portal.gloo.solo.io.APIProductListSummary, 1));
};


/** @param {!Array<!proto.app.portal.gloo.solo.io.APIProductListSummary>} value */
proto.app.portal.gloo.solo.io.APIProductListResponse.prototype.setApiProductsList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.app.portal.gloo.solo.io.APIProductListSummary=} opt_value
 * @param {number=} opt_index
 * @return {!proto.app.portal.gloo.solo.io.APIProductListSummary}
 */
proto.app.portal.gloo.solo.io.APIProductListResponse.prototype.addApiProducts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.app.portal.gloo.solo.io.APIProductListSummary, opt_index);
};


proto.app.portal.gloo.solo.io.APIProductListResponse.prototype.clearApiProductsList = function() {
  this.setApiProductsList([]);
};


/**
 * optional APIProductSearchInfo search_info = 2;
 * @return {?proto.app.portal.gloo.solo.io.APIProductSearchInfo}
 */
proto.app.portal.gloo.solo.io.APIProductListResponse.prototype.getSearchInfo = function() {
  return /** @type{?proto.app.portal.gloo.solo.io.APIProductSearchInfo} */ (
    jspb.Message.getWrapperField(this, proto.app.portal.gloo.solo.io.APIProductSearchInfo, 2));
};


/** @param {?proto.app.portal.gloo.solo.io.APIProductSearchInfo|undefined} value */
proto.app.portal.gloo.solo.io.APIProductListResponse.prototype.setSearchInfo = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


proto.app.portal.gloo.solo.io.APIProductListResponse.prototype.clearSearchInfo = function() {
  this.setSearchInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.app.portal.gloo.solo.io.APIProductListResponse.prototype.hasSearchInfo = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional bool portal_allow_all = 3;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.app.portal.gloo.solo.io.APIProductListResponse.prototype.getPortalAllowAll = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 3, false));
};


/** @param {boolean} value */
proto.app.portal.gloo.solo.io.APIProductListResponse.prototype.setPortalAllowAll = function(value) {
  jspb.Message.setProto3BooleanField(this, 3, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.app.portal.gloo.solo.io.APIProductListSummary = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.app.portal.gloo.solo.io.APIProductListSummary.repeatedFields_, null);
};
goog.inherits(proto.app.portal.gloo.solo.io.APIProductListSummary, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.app.portal.gloo.solo.io.APIProductListSummary.displayName = 'proto.app.portal.gloo.solo.io.APIProductListSummary';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.app.portal.gloo.solo.io.APIProductListSummary.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.app.portal.gloo.solo.io.APIProductListSummary.prototype.toObject = function(opt_includeInstance) {
  return proto.app.portal.gloo.solo.io.APIProductListSummary.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.app.portal.gloo.solo.io.APIProductListSummary} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.app.portal.gloo.solo.io.APIProductListSummary.toObject = function(includeInstance, msg) {
  var f, obj = {
    metadata: (f = msg.getMetadata()) && github_com_solo$io_dev$portal_api_grpc_common_common_pb.ObjectMeta.toObject(includeInstance, f),
    displayName: jspb.Message.getFieldWithDefault(msg, 2, ""),
    description: jspb.Message.getFieldWithDefault(msg, 3, ""),
    versionsList: jspb.Message.toObjectList(msg.getVersionsList(),
    proto.app.portal.gloo.solo.io.APIProductVersionSummary.toObject, includeInstance),
    imageUrl: jspb.Message.getFieldWithDefault(msg, 5, ""),
    modifiedDate: (f = msg.getModifiedDate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.app.portal.gloo.solo.io.APIProductListSummary}
 */
proto.app.portal.gloo.solo.io.APIProductListSummary.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.app.portal.gloo.solo.io.APIProductListSummary;
  return proto.app.portal.gloo.solo.io.APIProductListSummary.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.app.portal.gloo.solo.io.APIProductListSummary} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.app.portal.gloo.solo.io.APIProductListSummary}
 */
proto.app.portal.gloo.solo.io.APIProductListSummary.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new github_com_solo$io_dev$portal_api_grpc_common_common_pb.ObjectMeta;
      reader.readMessage(value,github_com_solo$io_dev$portal_api_grpc_common_common_pb.ObjectMeta.deserializeBinaryFromReader);
      msg.setMetadata(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDisplayName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 4:
      var value = new proto.app.portal.gloo.solo.io.APIProductVersionSummary;
      reader.readMessage(value,proto.app.portal.gloo.solo.io.APIProductVersionSummary.deserializeBinaryFromReader);
      msg.addVersions(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setImageUrl(value);
      break;
    case 6:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setModifiedDate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.app.portal.gloo.solo.io.APIProductListSummary.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.app.portal.gloo.solo.io.APIProductListSummary.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.app.portal.gloo.solo.io.APIProductListSummary} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.app.portal.gloo.solo.io.APIProductListSummary.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMetadata();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      github_com_solo$io_dev$portal_api_grpc_common_common_pb.ObjectMeta.serializeBinaryToWriter
    );
  }
  f = message.getDisplayName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getVersionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.app.portal.gloo.solo.io.APIProductVersionSummary.serializeBinaryToWriter
    );
  }
  f = message.getImageUrl();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getModifiedDate();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional common.portal.gloo.solo.io.ObjectMeta metadata = 1;
 * @return {?proto.common.portal.gloo.solo.io.ObjectMeta}
 */
proto.app.portal.gloo.solo.io.APIProductListSummary.prototype.getMetadata = function() {
  return /** @type{?proto.common.portal.gloo.solo.io.ObjectMeta} */ (
    jspb.Message.getWrapperField(this, github_com_solo$io_dev$portal_api_grpc_common_common_pb.ObjectMeta, 1));
};


/** @param {?proto.common.portal.gloo.solo.io.ObjectMeta|undefined} value */
proto.app.portal.gloo.solo.io.APIProductListSummary.prototype.setMetadata = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


proto.app.portal.gloo.solo.io.APIProductListSummary.prototype.clearMetadata = function() {
  this.setMetadata(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.app.portal.gloo.solo.io.APIProductListSummary.prototype.hasMetadata = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string display_name = 2;
 * @return {string}
 */
proto.app.portal.gloo.solo.io.APIProductListSummary.prototype.getDisplayName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.app.portal.gloo.solo.io.APIProductListSummary.prototype.setDisplayName = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string description = 3;
 * @return {string}
 */
proto.app.portal.gloo.solo.io.APIProductListSummary.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.app.portal.gloo.solo.io.APIProductListSummary.prototype.setDescription = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * repeated APIProductVersionSummary versions = 4;
 * @return {!Array<!proto.app.portal.gloo.solo.io.APIProductVersionSummary>}
 */
proto.app.portal.gloo.solo.io.APIProductListSummary.prototype.getVersionsList = function() {
  return /** @type{!Array<!proto.app.portal.gloo.solo.io.APIProductVersionSummary>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.app.portal.gloo.solo.io.APIProductVersionSummary, 4));
};


/** @param {!Array<!proto.app.portal.gloo.solo.io.APIProductVersionSummary>} value */
proto.app.portal.gloo.solo.io.APIProductListSummary.prototype.setVersionsList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.app.portal.gloo.solo.io.APIProductVersionSummary=} opt_value
 * @param {number=} opt_index
 * @return {!proto.app.portal.gloo.solo.io.APIProductVersionSummary}
 */
proto.app.portal.gloo.solo.io.APIProductListSummary.prototype.addVersions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.app.portal.gloo.solo.io.APIProductVersionSummary, opt_index);
};


proto.app.portal.gloo.solo.io.APIProductListSummary.prototype.clearVersionsList = function() {
  this.setVersionsList([]);
};


/**
 * optional string image_url = 5;
 * @return {string}
 */
proto.app.portal.gloo.solo.io.APIProductListSummary.prototype.getImageUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/** @param {string} value */
proto.app.portal.gloo.solo.io.APIProductListSummary.prototype.setImageUrl = function(value) {
  jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional google.protobuf.Timestamp modified_date = 6;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.app.portal.gloo.solo.io.APIProductListSummary.prototype.getModifiedDate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 6));
};


/** @param {?proto.google.protobuf.Timestamp|undefined} value */
proto.app.portal.gloo.solo.io.APIProductListSummary.prototype.setModifiedDate = function(value) {
  jspb.Message.setWrapperField(this, 6, value);
};


proto.app.portal.gloo.solo.io.APIProductListSummary.prototype.clearModifiedDate = function() {
  this.setModifiedDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.app.portal.gloo.solo.io.APIProductListSummary.prototype.hasModifiedDate = function() {
  return jspb.Message.getField(this, 6) != null;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.app.portal.gloo.solo.io.APIProductVersionSummary = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.app.portal.gloo.solo.io.APIProductVersionSummary.repeatedFields_, null);
};
goog.inherits(proto.app.portal.gloo.solo.io.APIProductVersionSummary, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.app.portal.gloo.solo.io.APIProductVersionSummary.displayName = 'proto.app.portal.gloo.solo.io.APIProductVersionSummary';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.app.portal.gloo.solo.io.APIProductVersionSummary.repeatedFields_ = [4,5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.app.portal.gloo.solo.io.APIProductVersionSummary.prototype.toObject = function(opt_includeInstance) {
  return proto.app.portal.gloo.solo.io.APIProductVersionSummary.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.app.portal.gloo.solo.io.APIProductVersionSummary} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.app.portal.gloo.solo.io.APIProductVersionSummary.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    externalName: jspb.Message.getFieldWithDefault(msg, 2, ""),
    operationsCount: jspb.Message.getFieldWithDefault(msg, 3, 0),
    environmentsList: jspb.Message.getRepeatedField(msg, 4),
    tagsList: jspb.Message.getRepeatedField(msg, 5),
    apiType: jspb.Message.getFieldWithDefault(msg, 6, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.app.portal.gloo.solo.io.APIProductVersionSummary}
 */
proto.app.portal.gloo.solo.io.APIProductVersionSummary.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.app.portal.gloo.solo.io.APIProductVersionSummary;
  return proto.app.portal.gloo.solo.io.APIProductVersionSummary.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.app.portal.gloo.solo.io.APIProductVersionSummary} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.app.portal.gloo.solo.io.APIProductVersionSummary}
 */
proto.app.portal.gloo.solo.io.APIProductVersionSummary.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setExternalName(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setOperationsCount(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.addEnvironments(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.addTags(value);
      break;
    case 6:
      var value = /** @type {!proto.portal.gloo.solo.io.APIType} */ (reader.readEnum());
      msg.setApiType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.app.portal.gloo.solo.io.APIProductVersionSummary.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.app.portal.gloo.solo.io.APIProductVersionSummary.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.app.portal.gloo.solo.io.APIProductVersionSummary} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.app.portal.gloo.solo.io.APIProductVersionSummary.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getExternalName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getOperationsCount();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getEnvironmentsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      4,
      f
    );
  }
  f = message.getTagsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      5,
      f
    );
  }
  f = message.getApiType();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.app.portal.gloo.solo.io.APIProductVersionSummary.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.app.portal.gloo.solo.io.APIProductVersionSummary.prototype.setName = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string external_name = 2;
 * @return {string}
 */
proto.app.portal.gloo.solo.io.APIProductVersionSummary.prototype.getExternalName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.app.portal.gloo.solo.io.APIProductVersionSummary.prototype.setExternalName = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional uint32 operations_count = 3;
 * @return {number}
 */
proto.app.portal.gloo.solo.io.APIProductVersionSummary.prototype.getOperationsCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.app.portal.gloo.solo.io.APIProductVersionSummary.prototype.setOperationsCount = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * repeated string environments = 4;
 * @return {!Array<string>}
 */
proto.app.portal.gloo.solo.io.APIProductVersionSummary.prototype.getEnvironmentsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 4));
};


/** @param {!Array<string>} value */
proto.app.portal.gloo.solo.io.APIProductVersionSummary.prototype.setEnvironmentsList = function(value) {
  jspb.Message.setField(this, 4, value || []);
};


/**
 * @param {!string} value
 * @param {number=} opt_index
 */
proto.app.portal.gloo.solo.io.APIProductVersionSummary.prototype.addEnvironments = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 4, value, opt_index);
};


proto.app.portal.gloo.solo.io.APIProductVersionSummary.prototype.clearEnvironmentsList = function() {
  this.setEnvironmentsList([]);
};


/**
 * repeated string tags = 5;
 * @return {!Array<string>}
 */
proto.app.portal.gloo.solo.io.APIProductVersionSummary.prototype.getTagsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 5));
};


/** @param {!Array<string>} value */
proto.app.portal.gloo.solo.io.APIProductVersionSummary.prototype.setTagsList = function(value) {
  jspb.Message.setField(this, 5, value || []);
};


/**
 * @param {!string} value
 * @param {number=} opt_index
 */
proto.app.portal.gloo.solo.io.APIProductVersionSummary.prototype.addTags = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 5, value, opt_index);
};


proto.app.portal.gloo.solo.io.APIProductVersionSummary.prototype.clearTagsList = function() {
  this.setTagsList([]);
};


/**
 * optional portal.gloo.solo.io.APIType api_type = 6;
 * @return {!proto.portal.gloo.solo.io.APIType}
 */
proto.app.portal.gloo.solo.io.APIProductVersionSummary.prototype.getApiType = function() {
  return /** @type {!proto.portal.gloo.solo.io.APIType} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/** @param {!proto.portal.gloo.solo.io.APIType} value */
proto.app.portal.gloo.solo.io.APIProductVersionSummary.prototype.setApiType = function(value) {
  jspb.Message.setProto3EnumField(this, 6, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.app.portal.gloo.solo.io.APIProductSearchInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.app.portal.gloo.solo.io.APIProductSearchInfo.repeatedFields_, null);
};
goog.inherits(proto.app.portal.gloo.solo.io.APIProductSearchInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.app.portal.gloo.solo.io.APIProductSearchInfo.displayName = 'proto.app.portal.gloo.solo.io.APIProductSearchInfo';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.app.portal.gloo.solo.io.APIProductSearchInfo.repeatedFields_ = [1,2,3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.app.portal.gloo.solo.io.APIProductSearchInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.app.portal.gloo.solo.io.APIProductSearchInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.app.portal.gloo.solo.io.APIProductSearchInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.app.portal.gloo.solo.io.APIProductSearchInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    environmentsList: jspb.Message.getRepeatedField(msg, 1),
    tagsList: jspb.Message.getRepeatedField(msg, 2),
    apiTypesList: jspb.Message.getRepeatedField(msg, 3)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.app.portal.gloo.solo.io.APIProductSearchInfo}
 */
proto.app.portal.gloo.solo.io.APIProductSearchInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.app.portal.gloo.solo.io.APIProductSearchInfo;
  return proto.app.portal.gloo.solo.io.APIProductSearchInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.app.portal.gloo.solo.io.APIProductSearchInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.app.portal.gloo.solo.io.APIProductSearchInfo}
 */
proto.app.portal.gloo.solo.io.APIProductSearchInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addEnvironments(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addTags(value);
      break;
    case 3:
      var value = /** @type {!Array<!proto.portal.gloo.solo.io.APIType>} */ (reader.readPackedEnum());
      msg.setApiTypesList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.app.portal.gloo.solo.io.APIProductSearchInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.app.portal.gloo.solo.io.APIProductSearchInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.app.portal.gloo.solo.io.APIProductSearchInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.app.portal.gloo.solo.io.APIProductSearchInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEnvironmentsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
  f = message.getTagsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
  f = message.getApiTypesList();
  if (f.length > 0) {
    writer.writePackedEnum(
      3,
      f
    );
  }
};


/**
 * repeated string environments = 1;
 * @return {!Array<string>}
 */
proto.app.portal.gloo.solo.io.APIProductSearchInfo.prototype.getEnvironmentsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/** @param {!Array<string>} value */
proto.app.portal.gloo.solo.io.APIProductSearchInfo.prototype.setEnvironmentsList = function(value) {
  jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {!string} value
 * @param {number=} opt_index
 */
proto.app.portal.gloo.solo.io.APIProductSearchInfo.prototype.addEnvironments = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


proto.app.portal.gloo.solo.io.APIProductSearchInfo.prototype.clearEnvironmentsList = function() {
  this.setEnvironmentsList([]);
};


/**
 * repeated string tags = 2;
 * @return {!Array<string>}
 */
proto.app.portal.gloo.solo.io.APIProductSearchInfo.prototype.getTagsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/** @param {!Array<string>} value */
proto.app.portal.gloo.solo.io.APIProductSearchInfo.prototype.setTagsList = function(value) {
  jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {!string} value
 * @param {number=} opt_index
 */
proto.app.portal.gloo.solo.io.APIProductSearchInfo.prototype.addTags = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


proto.app.portal.gloo.solo.io.APIProductSearchInfo.prototype.clearTagsList = function() {
  this.setTagsList([]);
};


/**
 * repeated portal.gloo.solo.io.APIType api_types = 3;
 * @return {!Array<!proto.portal.gloo.solo.io.APIType>}
 */
proto.app.portal.gloo.solo.io.APIProductSearchInfo.prototype.getApiTypesList = function() {
  return /** @type {!Array<!proto.portal.gloo.solo.io.APIType>} */ (jspb.Message.getRepeatedField(this, 3));
};


/** @param {!Array<!proto.portal.gloo.solo.io.APIType>} value */
proto.app.portal.gloo.solo.io.APIProductSearchInfo.prototype.setApiTypesList = function(value) {
  jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {!proto.portal.gloo.solo.io.APIType} value
 * @param {number=} opt_index
 */
proto.app.portal.gloo.solo.io.APIProductSearchInfo.prototype.addApiTypes = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


proto.app.portal.gloo.solo.io.APIProductSearchInfo.prototype.clearApiTypesList = function() {
  this.setApiTypesList([]);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.app.portal.gloo.solo.io.APIProductDetails = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.app.portal.gloo.solo.io.APIProductDetails.repeatedFields_, null);
};
goog.inherits(proto.app.portal.gloo.solo.io.APIProductDetails, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.app.portal.gloo.solo.io.APIProductDetails.displayName = 'proto.app.portal.gloo.solo.io.APIProductDetails';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.app.portal.gloo.solo.io.APIProductDetails.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.app.portal.gloo.solo.io.APIProductDetails.prototype.toObject = function(opt_includeInstance) {
  return proto.app.portal.gloo.solo.io.APIProductDetails.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.app.portal.gloo.solo.io.APIProductDetails} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.app.portal.gloo.solo.io.APIProductDetails.toObject = function(includeInstance, msg) {
  var f, obj = {
    metadata: (f = msg.getMetadata()) && github_com_solo$io_dev$portal_api_grpc_common_common_pb.ObjectMeta.toObject(includeInstance, f),
    displayname: jspb.Message.getFieldWithDefault(msg, 2, ""),
    description: jspb.Message.getFieldWithDefault(msg, 3, ""),
    environmentsList: jspb.Message.toObjectList(msg.getEnvironmentsList(),
    proto.app.portal.gloo.solo.io.EnvironmentVersionList.toObject, includeInstance),
    imageUrl: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.app.portal.gloo.solo.io.APIProductDetails}
 */
proto.app.portal.gloo.solo.io.APIProductDetails.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.app.portal.gloo.solo.io.APIProductDetails;
  return proto.app.portal.gloo.solo.io.APIProductDetails.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.app.portal.gloo.solo.io.APIProductDetails} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.app.portal.gloo.solo.io.APIProductDetails}
 */
proto.app.portal.gloo.solo.io.APIProductDetails.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new github_com_solo$io_dev$portal_api_grpc_common_common_pb.ObjectMeta;
      reader.readMessage(value,github_com_solo$io_dev$portal_api_grpc_common_common_pb.ObjectMeta.deserializeBinaryFromReader);
      msg.setMetadata(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDisplayname(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 4:
      var value = new proto.app.portal.gloo.solo.io.EnvironmentVersionList;
      reader.readMessage(value,proto.app.portal.gloo.solo.io.EnvironmentVersionList.deserializeBinaryFromReader);
      msg.addEnvironments(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setImageUrl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.app.portal.gloo.solo.io.APIProductDetails.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.app.portal.gloo.solo.io.APIProductDetails.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.app.portal.gloo.solo.io.APIProductDetails} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.app.portal.gloo.solo.io.APIProductDetails.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMetadata();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      github_com_solo$io_dev$portal_api_grpc_common_common_pb.ObjectMeta.serializeBinaryToWriter
    );
  }
  f = message.getDisplayname();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getEnvironmentsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.app.portal.gloo.solo.io.EnvironmentVersionList.serializeBinaryToWriter
    );
  }
  f = message.getImageUrl();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional common.portal.gloo.solo.io.ObjectMeta metadata = 1;
 * @return {?proto.common.portal.gloo.solo.io.ObjectMeta}
 */
proto.app.portal.gloo.solo.io.APIProductDetails.prototype.getMetadata = function() {
  return /** @type{?proto.common.portal.gloo.solo.io.ObjectMeta} */ (
    jspb.Message.getWrapperField(this, github_com_solo$io_dev$portal_api_grpc_common_common_pb.ObjectMeta, 1));
};


/** @param {?proto.common.portal.gloo.solo.io.ObjectMeta|undefined} value */
proto.app.portal.gloo.solo.io.APIProductDetails.prototype.setMetadata = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


proto.app.portal.gloo.solo.io.APIProductDetails.prototype.clearMetadata = function() {
  this.setMetadata(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.app.portal.gloo.solo.io.APIProductDetails.prototype.hasMetadata = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string displayName = 2;
 * @return {string}
 */
proto.app.portal.gloo.solo.io.APIProductDetails.prototype.getDisplayname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.app.portal.gloo.solo.io.APIProductDetails.prototype.setDisplayname = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string description = 3;
 * @return {string}
 */
proto.app.portal.gloo.solo.io.APIProductDetails.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.app.portal.gloo.solo.io.APIProductDetails.prototype.setDescription = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * repeated EnvironmentVersionList environments = 4;
 * @return {!Array<!proto.app.portal.gloo.solo.io.EnvironmentVersionList>}
 */
proto.app.portal.gloo.solo.io.APIProductDetails.prototype.getEnvironmentsList = function() {
  return /** @type{!Array<!proto.app.portal.gloo.solo.io.EnvironmentVersionList>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.app.portal.gloo.solo.io.EnvironmentVersionList, 4));
};


/** @param {!Array<!proto.app.portal.gloo.solo.io.EnvironmentVersionList>} value */
proto.app.portal.gloo.solo.io.APIProductDetails.prototype.setEnvironmentsList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.app.portal.gloo.solo.io.EnvironmentVersionList=} opt_value
 * @param {number=} opt_index
 * @return {!proto.app.portal.gloo.solo.io.EnvironmentVersionList}
 */
proto.app.portal.gloo.solo.io.APIProductDetails.prototype.addEnvironments = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.app.portal.gloo.solo.io.EnvironmentVersionList, opt_index);
};


proto.app.portal.gloo.solo.io.APIProductDetails.prototype.clearEnvironmentsList = function() {
  this.setEnvironmentsList([]);
};


/**
 * optional string image_url = 5;
 * @return {string}
 */
proto.app.portal.gloo.solo.io.APIProductDetails.prototype.getImageUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/** @param {string} value */
proto.app.portal.gloo.solo.io.APIProductDetails.prototype.setImageUrl = function(value) {
  jspb.Message.setProto3StringField(this, 5, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.app.portal.gloo.solo.io.EnvironmentVersionList = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.app.portal.gloo.solo.io.EnvironmentVersionList.repeatedFields_, null);
};
goog.inherits(proto.app.portal.gloo.solo.io.EnvironmentVersionList, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.app.portal.gloo.solo.io.EnvironmentVersionList.displayName = 'proto.app.portal.gloo.solo.io.EnvironmentVersionList';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.app.portal.gloo.solo.io.EnvironmentVersionList.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.app.portal.gloo.solo.io.EnvironmentVersionList.prototype.toObject = function(opt_includeInstance) {
  return proto.app.portal.gloo.solo.io.EnvironmentVersionList.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.app.portal.gloo.solo.io.EnvironmentVersionList} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.app.portal.gloo.solo.io.EnvironmentVersionList.toObject = function(includeInstance, msg) {
  var f, obj = {
    metadata: (f = msg.getMetadata()) && github_com_solo$io_dev$portal_api_grpc_common_common_pb.ObjectMeta.toObject(includeInstance, f),
    displayname: jspb.Message.getFieldWithDefault(msg, 2, ""),
    versionsList: jspb.Message.getRepeatedField(msg, 3)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.app.portal.gloo.solo.io.EnvironmentVersionList}
 */
proto.app.portal.gloo.solo.io.EnvironmentVersionList.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.app.portal.gloo.solo.io.EnvironmentVersionList;
  return proto.app.portal.gloo.solo.io.EnvironmentVersionList.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.app.portal.gloo.solo.io.EnvironmentVersionList} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.app.portal.gloo.solo.io.EnvironmentVersionList}
 */
proto.app.portal.gloo.solo.io.EnvironmentVersionList.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new github_com_solo$io_dev$portal_api_grpc_common_common_pb.ObjectMeta;
      reader.readMessage(value,github_com_solo$io_dev$portal_api_grpc_common_common_pb.ObjectMeta.deserializeBinaryFromReader);
      msg.setMetadata(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDisplayname(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addVersions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.app.portal.gloo.solo.io.EnvironmentVersionList.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.app.portal.gloo.solo.io.EnvironmentVersionList.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.app.portal.gloo.solo.io.EnvironmentVersionList} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.app.portal.gloo.solo.io.EnvironmentVersionList.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMetadata();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      github_com_solo$io_dev$portal_api_grpc_common_common_pb.ObjectMeta.serializeBinaryToWriter
    );
  }
  f = message.getDisplayname();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getVersionsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
};


/**
 * optional common.portal.gloo.solo.io.ObjectMeta metadata = 1;
 * @return {?proto.common.portal.gloo.solo.io.ObjectMeta}
 */
proto.app.portal.gloo.solo.io.EnvironmentVersionList.prototype.getMetadata = function() {
  return /** @type{?proto.common.portal.gloo.solo.io.ObjectMeta} */ (
    jspb.Message.getWrapperField(this, github_com_solo$io_dev$portal_api_grpc_common_common_pb.ObjectMeta, 1));
};


/** @param {?proto.common.portal.gloo.solo.io.ObjectMeta|undefined} value */
proto.app.portal.gloo.solo.io.EnvironmentVersionList.prototype.setMetadata = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


proto.app.portal.gloo.solo.io.EnvironmentVersionList.prototype.clearMetadata = function() {
  this.setMetadata(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.app.portal.gloo.solo.io.EnvironmentVersionList.prototype.hasMetadata = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string displayName = 2;
 * @return {string}
 */
proto.app.portal.gloo.solo.io.EnvironmentVersionList.prototype.getDisplayname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.app.portal.gloo.solo.io.EnvironmentVersionList.prototype.setDisplayname = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated string versions = 3;
 * @return {!Array<string>}
 */
proto.app.portal.gloo.solo.io.EnvironmentVersionList.prototype.getVersionsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/** @param {!Array<string>} value */
proto.app.portal.gloo.solo.io.EnvironmentVersionList.prototype.setVersionsList = function(value) {
  jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {!string} value
 * @param {number=} opt_index
 */
proto.app.portal.gloo.solo.io.EnvironmentVersionList.prototype.addVersions = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


proto.app.portal.gloo.solo.io.EnvironmentVersionList.prototype.clearVersionsList = function() {
  this.setVersionsList([]);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.app.portal.gloo.solo.io.APIProductVersionDetailsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.app.portal.gloo.solo.io.APIProductVersionDetailsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.app.portal.gloo.solo.io.APIProductVersionDetailsRequest.displayName = 'proto.app.portal.gloo.solo.io.APIProductVersionDetailsRequest';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.app.portal.gloo.solo.io.APIProductVersionDetailsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.app.portal.gloo.solo.io.APIProductVersionDetailsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.app.portal.gloo.solo.io.APIProductVersionDetailsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.app.portal.gloo.solo.io.APIProductVersionDetailsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    apiProductRef: (f = msg.getApiProductRef()) && github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.ObjectRef.toObject(includeInstance, f),
    environmentRef: (f = msg.getEnvironmentRef()) && github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.ObjectRef.toObject(includeInstance, f),
    version: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.app.portal.gloo.solo.io.APIProductVersionDetailsRequest}
 */
proto.app.portal.gloo.solo.io.APIProductVersionDetailsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.app.portal.gloo.solo.io.APIProductVersionDetailsRequest;
  return proto.app.portal.gloo.solo.io.APIProductVersionDetailsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.app.portal.gloo.solo.io.APIProductVersionDetailsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.app.portal.gloo.solo.io.APIProductVersionDetailsRequest}
 */
proto.app.portal.gloo.solo.io.APIProductVersionDetailsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.ObjectRef;
      reader.readMessage(value,github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.ObjectRef.deserializeBinaryFromReader);
      msg.setApiProductRef(value);
      break;
    case 2:
      var value = new github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.ObjectRef;
      reader.readMessage(value,github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.ObjectRef.deserializeBinaryFromReader);
      msg.setEnvironmentRef(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setVersion(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.app.portal.gloo.solo.io.APIProductVersionDetailsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.app.portal.gloo.solo.io.APIProductVersionDetailsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.app.portal.gloo.solo.io.APIProductVersionDetailsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.app.portal.gloo.solo.io.APIProductVersionDetailsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getApiProductRef();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.ObjectRef.serializeBinaryToWriter
    );
  }
  f = message.getEnvironmentRef();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.ObjectRef.serializeBinaryToWriter
    );
  }
  f = message.getVersion();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional common.portal.gloo.solo.io.ObjectRef api_product_ref = 1;
 * @return {?proto.common.portal.gloo.solo.io.ObjectRef}
 */
proto.app.portal.gloo.solo.io.APIProductVersionDetailsRequest.prototype.getApiProductRef = function() {
  return /** @type{?proto.common.portal.gloo.solo.io.ObjectRef} */ (
    jspb.Message.getWrapperField(this, github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.ObjectRef, 1));
};


/** @param {?proto.common.portal.gloo.solo.io.ObjectRef|undefined} value */
proto.app.portal.gloo.solo.io.APIProductVersionDetailsRequest.prototype.setApiProductRef = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


proto.app.portal.gloo.solo.io.APIProductVersionDetailsRequest.prototype.clearApiProductRef = function() {
  this.setApiProductRef(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.app.portal.gloo.solo.io.APIProductVersionDetailsRequest.prototype.hasApiProductRef = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional common.portal.gloo.solo.io.ObjectRef environment_ref = 2;
 * @return {?proto.common.portal.gloo.solo.io.ObjectRef}
 */
proto.app.portal.gloo.solo.io.APIProductVersionDetailsRequest.prototype.getEnvironmentRef = function() {
  return /** @type{?proto.common.portal.gloo.solo.io.ObjectRef} */ (
    jspb.Message.getWrapperField(this, github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.ObjectRef, 2));
};


/** @param {?proto.common.portal.gloo.solo.io.ObjectRef|undefined} value */
proto.app.portal.gloo.solo.io.APIProductVersionDetailsRequest.prototype.setEnvironmentRef = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


proto.app.portal.gloo.solo.io.APIProductVersionDetailsRequest.prototype.clearEnvironmentRef = function() {
  this.setEnvironmentRef(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.app.portal.gloo.solo.io.APIProductVersionDetailsRequest.prototype.hasEnvironmentRef = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string version = 3;
 * @return {string}
 */
proto.app.portal.gloo.solo.io.APIProductVersionDetailsRequest.prototype.getVersion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.app.portal.gloo.solo.io.APIProductVersionDetailsRequest.prototype.setVersion = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.app.portal.gloo.solo.io.APIProductVersionDetails = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.app.portal.gloo.solo.io.APIProductVersionDetails.repeatedFields_, null);
};
goog.inherits(proto.app.portal.gloo.solo.io.APIProductVersionDetails, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.app.portal.gloo.solo.io.APIProductVersionDetails.displayName = 'proto.app.portal.gloo.solo.io.APIProductVersionDetails';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.app.portal.gloo.solo.io.APIProductVersionDetails.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.app.portal.gloo.solo.io.APIProductVersionDetails.prototype.toObject = function(opt_includeInstance) {
  return proto.app.portal.gloo.solo.io.APIProductVersionDetails.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.app.portal.gloo.solo.io.APIProductVersionDetails} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.app.portal.gloo.solo.io.APIProductVersionDetails.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    externalName: jspb.Message.getFieldWithDefault(msg, 2, ""),
    tagsList: jspb.Message.getRepeatedField(msg, 3),
    operationsSpec: jspb.Message.getFieldWithDefault(msg, 4, ""),
    operationsDisabled: jspb.Message.getFieldWithDefault(msg, 5, false),
    portalUrlPrefix: jspb.Message.getFieldWithDefault(msg, 6, ""),
    apiType: jspb.Message.getFieldWithDefault(msg, 7, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.app.portal.gloo.solo.io.APIProductVersionDetails}
 */
proto.app.portal.gloo.solo.io.APIProductVersionDetails.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.app.portal.gloo.solo.io.APIProductVersionDetails;
  return proto.app.portal.gloo.solo.io.APIProductVersionDetails.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.app.portal.gloo.solo.io.APIProductVersionDetails} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.app.portal.gloo.solo.io.APIProductVersionDetails}
 */
proto.app.portal.gloo.solo.io.APIProductVersionDetails.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setExternalName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addTags(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setOperationsSpec(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setOperationsDisabled(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setPortalUrlPrefix(value);
      break;
    case 7:
      var value = /** @type {!proto.portal.gloo.solo.io.APIType} */ (reader.readEnum());
      msg.setApiType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.app.portal.gloo.solo.io.APIProductVersionDetails.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.app.portal.gloo.solo.io.APIProductVersionDetails.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.app.portal.gloo.solo.io.APIProductVersionDetails} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.app.portal.gloo.solo.io.APIProductVersionDetails.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getExternalName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTagsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
  f = message.getOperationsSpec();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getOperationsDisabled();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getPortalUrlPrefix();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getApiType();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.app.portal.gloo.solo.io.APIProductVersionDetails.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.app.portal.gloo.solo.io.APIProductVersionDetails.prototype.setName = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string external_name = 2;
 * @return {string}
 */
proto.app.portal.gloo.solo.io.APIProductVersionDetails.prototype.getExternalName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.app.portal.gloo.solo.io.APIProductVersionDetails.prototype.setExternalName = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated string tags = 3;
 * @return {!Array<string>}
 */
proto.app.portal.gloo.solo.io.APIProductVersionDetails.prototype.getTagsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/** @param {!Array<string>} value */
proto.app.portal.gloo.solo.io.APIProductVersionDetails.prototype.setTagsList = function(value) {
  jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {!string} value
 * @param {number=} opt_index
 */
proto.app.portal.gloo.solo.io.APIProductVersionDetails.prototype.addTags = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


proto.app.portal.gloo.solo.io.APIProductVersionDetails.prototype.clearTagsList = function() {
  this.setTagsList([]);
};


/**
 * optional string operations_spec = 4;
 * @return {string}
 */
proto.app.portal.gloo.solo.io.APIProductVersionDetails.prototype.getOperationsSpec = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.app.portal.gloo.solo.io.APIProductVersionDetails.prototype.setOperationsSpec = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional bool operations_disabled = 5;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.app.portal.gloo.solo.io.APIProductVersionDetails.prototype.getOperationsDisabled = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 5, false));
};


/** @param {boolean} value */
proto.app.portal.gloo.solo.io.APIProductVersionDetails.prototype.setOperationsDisabled = function(value) {
  jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * optional string portal_url_prefix = 6;
 * @return {string}
 */
proto.app.portal.gloo.solo.io.APIProductVersionDetails.prototype.getPortalUrlPrefix = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/** @param {string} value */
proto.app.portal.gloo.solo.io.APIProductVersionDetails.prototype.setPortalUrlPrefix = function(value) {
  jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional portal.gloo.solo.io.APIType api_type = 7;
 * @return {!proto.portal.gloo.solo.io.APIType}
 */
proto.app.portal.gloo.solo.io.APIProductVersionDetails.prototype.getApiType = function() {
  return /** @type {!proto.portal.gloo.solo.io.APIType} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/** @param {!proto.portal.gloo.solo.io.APIType} value */
proto.app.portal.gloo.solo.io.APIProductVersionDetails.prototype.setApiType = function(value) {
  jspb.Message.setProto3EnumField(this, 7, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.app.portal.gloo.solo.io.APIProductPlansListResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.app.portal.gloo.solo.io.APIProductPlansListResponse.repeatedFields_, null);
};
goog.inherits(proto.app.portal.gloo.solo.io.APIProductPlansListResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.app.portal.gloo.solo.io.APIProductPlansListResponse.displayName = 'proto.app.portal.gloo.solo.io.APIProductPlansListResponse';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.app.portal.gloo.solo.io.APIProductPlansListResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.app.portal.gloo.solo.io.APIProductPlansListResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.app.portal.gloo.solo.io.APIProductPlansListResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.app.portal.gloo.solo.io.APIProductPlansListResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.app.portal.gloo.solo.io.APIProductPlansListResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    apiProductsList: jspb.Message.toObjectList(msg.getApiProductsList(),
    proto.app.portal.gloo.solo.io.APIProductPlanListSummary.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.app.portal.gloo.solo.io.APIProductPlansListResponse}
 */
proto.app.portal.gloo.solo.io.APIProductPlansListResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.app.portal.gloo.solo.io.APIProductPlansListResponse;
  return proto.app.portal.gloo.solo.io.APIProductPlansListResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.app.portal.gloo.solo.io.APIProductPlansListResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.app.portal.gloo.solo.io.APIProductPlansListResponse}
 */
proto.app.portal.gloo.solo.io.APIProductPlansListResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.app.portal.gloo.solo.io.APIProductPlanListSummary;
      reader.readMessage(value,proto.app.portal.gloo.solo.io.APIProductPlanListSummary.deserializeBinaryFromReader);
      msg.addApiProducts(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.app.portal.gloo.solo.io.APIProductPlansListResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.app.portal.gloo.solo.io.APIProductPlansListResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.app.portal.gloo.solo.io.APIProductPlansListResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.app.portal.gloo.solo.io.APIProductPlansListResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getApiProductsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.app.portal.gloo.solo.io.APIProductPlanListSummary.serializeBinaryToWriter
    );
  }
};


/**
 * repeated APIProductPlanListSummary api_products = 1;
 * @return {!Array<!proto.app.portal.gloo.solo.io.APIProductPlanListSummary>}
 */
proto.app.portal.gloo.solo.io.APIProductPlansListResponse.prototype.getApiProductsList = function() {
  return /** @type{!Array<!proto.app.portal.gloo.solo.io.APIProductPlanListSummary>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.app.portal.gloo.solo.io.APIProductPlanListSummary, 1));
};


/** @param {!Array<!proto.app.portal.gloo.solo.io.APIProductPlanListSummary>} value */
proto.app.portal.gloo.solo.io.APIProductPlansListResponse.prototype.setApiProductsList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.app.portal.gloo.solo.io.APIProductPlanListSummary=} opt_value
 * @param {number=} opt_index
 * @return {!proto.app.portal.gloo.solo.io.APIProductPlanListSummary}
 */
proto.app.portal.gloo.solo.io.APIProductPlansListResponse.prototype.addApiProducts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.app.portal.gloo.solo.io.APIProductPlanListSummary, opt_index);
};


proto.app.portal.gloo.solo.io.APIProductPlansListResponse.prototype.clearApiProductsList = function() {
  this.setApiProductsList([]);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.app.portal.gloo.solo.io.APIProductPlanListSummary = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.app.portal.gloo.solo.io.APIProductPlanListSummary, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.app.portal.gloo.solo.io.APIProductPlanListSummary.displayName = 'proto.app.portal.gloo.solo.io.APIProductPlanListSummary';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.app.portal.gloo.solo.io.APIProductPlanListSummary.prototype.toObject = function(opt_includeInstance) {
  return proto.app.portal.gloo.solo.io.APIProductPlanListSummary.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.app.portal.gloo.solo.io.APIProductPlanListSummary} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.app.portal.gloo.solo.io.APIProductPlanListSummary.toObject = function(includeInstance, msg) {
  var f, obj = {
    metadata: (f = msg.getMetadata()) && github_com_solo$io_dev$portal_api_grpc_common_common_pb.ObjectMeta.toObject(includeInstance, f),
    displayName: jspb.Message.getFieldWithDefault(msg, 2, ""),
    description: jspb.Message.getFieldWithDefault(msg, 3, ""),
    apiKeyCount: jspb.Message.getFieldWithDefault(msg, 4, 0),
    planCount: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.app.portal.gloo.solo.io.APIProductPlanListSummary}
 */
proto.app.portal.gloo.solo.io.APIProductPlanListSummary.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.app.portal.gloo.solo.io.APIProductPlanListSummary;
  return proto.app.portal.gloo.solo.io.APIProductPlanListSummary.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.app.portal.gloo.solo.io.APIProductPlanListSummary} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.app.portal.gloo.solo.io.APIProductPlanListSummary}
 */
proto.app.portal.gloo.solo.io.APIProductPlanListSummary.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new github_com_solo$io_dev$portal_api_grpc_common_common_pb.ObjectMeta;
      reader.readMessage(value,github_com_solo$io_dev$portal_api_grpc_common_common_pb.ObjectMeta.deserializeBinaryFromReader);
      msg.setMetadata(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDisplayName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setApiKeyCount(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPlanCount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.app.portal.gloo.solo.io.APIProductPlanListSummary.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.app.portal.gloo.solo.io.APIProductPlanListSummary.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.app.portal.gloo.solo.io.APIProductPlanListSummary} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.app.portal.gloo.solo.io.APIProductPlanListSummary.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMetadata();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      github_com_solo$io_dev$portal_api_grpc_common_common_pb.ObjectMeta.serializeBinaryToWriter
    );
  }
  f = message.getDisplayName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getApiKeyCount();
  if (f !== 0) {
    writer.writeUint32(
      4,
      f
    );
  }
  f = message.getPlanCount();
  if (f !== 0) {
    writer.writeUint32(
      5,
      f
    );
  }
};


/**
 * optional common.portal.gloo.solo.io.ObjectMeta metadata = 1;
 * @return {?proto.common.portal.gloo.solo.io.ObjectMeta}
 */
proto.app.portal.gloo.solo.io.APIProductPlanListSummary.prototype.getMetadata = function() {
  return /** @type{?proto.common.portal.gloo.solo.io.ObjectMeta} */ (
    jspb.Message.getWrapperField(this, github_com_solo$io_dev$portal_api_grpc_common_common_pb.ObjectMeta, 1));
};


/** @param {?proto.common.portal.gloo.solo.io.ObjectMeta|undefined} value */
proto.app.portal.gloo.solo.io.APIProductPlanListSummary.prototype.setMetadata = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


proto.app.portal.gloo.solo.io.APIProductPlanListSummary.prototype.clearMetadata = function() {
  this.setMetadata(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.app.portal.gloo.solo.io.APIProductPlanListSummary.prototype.hasMetadata = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string display_name = 2;
 * @return {string}
 */
proto.app.portal.gloo.solo.io.APIProductPlanListSummary.prototype.getDisplayName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.app.portal.gloo.solo.io.APIProductPlanListSummary.prototype.setDisplayName = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string description = 3;
 * @return {string}
 */
proto.app.portal.gloo.solo.io.APIProductPlanListSummary.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.app.portal.gloo.solo.io.APIProductPlanListSummary.prototype.setDescription = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional uint32 api_key_count = 4;
 * @return {number}
 */
proto.app.portal.gloo.solo.io.APIProductPlanListSummary.prototype.getApiKeyCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.app.portal.gloo.solo.io.APIProductPlanListSummary.prototype.setApiKeyCount = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional uint32 plan_count = 5;
 * @return {number}
 */
proto.app.portal.gloo.solo.io.APIProductPlanListSummary.prototype.getPlanCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {number} value */
proto.app.portal.gloo.solo.io.APIProductPlanListSummary.prototype.setPlanCount = function(value) {
  jspb.Message.setProto3IntField(this, 5, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.app.portal.gloo.solo.io.APIProductPlanDetailsListResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.app.portal.gloo.solo.io.APIProductPlanDetailsListResponse.repeatedFields_, null);
};
goog.inherits(proto.app.portal.gloo.solo.io.APIProductPlanDetailsListResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.app.portal.gloo.solo.io.APIProductPlanDetailsListResponse.displayName = 'proto.app.portal.gloo.solo.io.APIProductPlanDetailsListResponse';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.app.portal.gloo.solo.io.APIProductPlanDetailsListResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.app.portal.gloo.solo.io.APIProductPlanDetailsListResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.app.portal.gloo.solo.io.APIProductPlanDetailsListResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.app.portal.gloo.solo.io.APIProductPlanDetailsListResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.app.portal.gloo.solo.io.APIProductPlanDetailsListResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    environmentsList: jspb.Message.toObjectList(msg.getEnvironmentsList(),
    proto.app.portal.gloo.solo.io.EnvironmentPlans.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.app.portal.gloo.solo.io.APIProductPlanDetailsListResponse}
 */
proto.app.portal.gloo.solo.io.APIProductPlanDetailsListResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.app.portal.gloo.solo.io.APIProductPlanDetailsListResponse;
  return proto.app.portal.gloo.solo.io.APIProductPlanDetailsListResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.app.portal.gloo.solo.io.APIProductPlanDetailsListResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.app.portal.gloo.solo.io.APIProductPlanDetailsListResponse}
 */
proto.app.portal.gloo.solo.io.APIProductPlanDetailsListResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.app.portal.gloo.solo.io.EnvironmentPlans;
      reader.readMessage(value,proto.app.portal.gloo.solo.io.EnvironmentPlans.deserializeBinaryFromReader);
      msg.addEnvironments(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.app.portal.gloo.solo.io.APIProductPlanDetailsListResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.app.portal.gloo.solo.io.APIProductPlanDetailsListResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.app.portal.gloo.solo.io.APIProductPlanDetailsListResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.app.portal.gloo.solo.io.APIProductPlanDetailsListResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEnvironmentsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.app.portal.gloo.solo.io.EnvironmentPlans.serializeBinaryToWriter
    );
  }
};


/**
 * repeated EnvironmentPlans environments = 1;
 * @return {!Array<!proto.app.portal.gloo.solo.io.EnvironmentPlans>}
 */
proto.app.portal.gloo.solo.io.APIProductPlanDetailsListResponse.prototype.getEnvironmentsList = function() {
  return /** @type{!Array<!proto.app.portal.gloo.solo.io.EnvironmentPlans>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.app.portal.gloo.solo.io.EnvironmentPlans, 1));
};


/** @param {!Array<!proto.app.portal.gloo.solo.io.EnvironmentPlans>} value */
proto.app.portal.gloo.solo.io.APIProductPlanDetailsListResponse.prototype.setEnvironmentsList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.app.portal.gloo.solo.io.EnvironmentPlans=} opt_value
 * @param {number=} opt_index
 * @return {!proto.app.portal.gloo.solo.io.EnvironmentPlans}
 */
proto.app.portal.gloo.solo.io.APIProductPlanDetailsListResponse.prototype.addEnvironments = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.app.portal.gloo.solo.io.EnvironmentPlans, opt_index);
};


proto.app.portal.gloo.solo.io.APIProductPlanDetailsListResponse.prototype.clearEnvironmentsList = function() {
  this.setEnvironmentsList([]);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.app.portal.gloo.solo.io.EnvironmentPlans = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.app.portal.gloo.solo.io.EnvironmentPlans.repeatedFields_, null);
};
goog.inherits(proto.app.portal.gloo.solo.io.EnvironmentPlans, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.app.portal.gloo.solo.io.EnvironmentPlans.displayName = 'proto.app.portal.gloo.solo.io.EnvironmentPlans';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.app.portal.gloo.solo.io.EnvironmentPlans.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.app.portal.gloo.solo.io.EnvironmentPlans.prototype.toObject = function(opt_includeInstance) {
  return proto.app.portal.gloo.solo.io.EnvironmentPlans.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.app.portal.gloo.solo.io.EnvironmentPlans} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.app.portal.gloo.solo.io.EnvironmentPlans.toObject = function(includeInstance, msg) {
  var f, obj = {
    metadata: (f = msg.getMetadata()) && github_com_solo$io_dev$portal_api_grpc_common_common_pb.ObjectMeta.toObject(includeInstance, f),
    displayName: jspb.Message.getFieldWithDefault(msg, 2, ""),
    plansList: jspb.Message.toObjectList(msg.getPlansList(),
    proto.app.portal.gloo.solo.io.PlanSummary.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.app.portal.gloo.solo.io.EnvironmentPlans}
 */
proto.app.portal.gloo.solo.io.EnvironmentPlans.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.app.portal.gloo.solo.io.EnvironmentPlans;
  return proto.app.portal.gloo.solo.io.EnvironmentPlans.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.app.portal.gloo.solo.io.EnvironmentPlans} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.app.portal.gloo.solo.io.EnvironmentPlans}
 */
proto.app.portal.gloo.solo.io.EnvironmentPlans.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new github_com_solo$io_dev$portal_api_grpc_common_common_pb.ObjectMeta;
      reader.readMessage(value,github_com_solo$io_dev$portal_api_grpc_common_common_pb.ObjectMeta.deserializeBinaryFromReader);
      msg.setMetadata(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDisplayName(value);
      break;
    case 3:
      var value = new proto.app.portal.gloo.solo.io.PlanSummary;
      reader.readMessage(value,proto.app.portal.gloo.solo.io.PlanSummary.deserializeBinaryFromReader);
      msg.addPlans(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.app.portal.gloo.solo.io.EnvironmentPlans.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.app.portal.gloo.solo.io.EnvironmentPlans.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.app.portal.gloo.solo.io.EnvironmentPlans} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.app.portal.gloo.solo.io.EnvironmentPlans.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMetadata();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      github_com_solo$io_dev$portal_api_grpc_common_common_pb.ObjectMeta.serializeBinaryToWriter
    );
  }
  f = message.getDisplayName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPlansList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.app.portal.gloo.solo.io.PlanSummary.serializeBinaryToWriter
    );
  }
};


/**
 * optional common.portal.gloo.solo.io.ObjectMeta metadata = 1;
 * @return {?proto.common.portal.gloo.solo.io.ObjectMeta}
 */
proto.app.portal.gloo.solo.io.EnvironmentPlans.prototype.getMetadata = function() {
  return /** @type{?proto.common.portal.gloo.solo.io.ObjectMeta} */ (
    jspb.Message.getWrapperField(this, github_com_solo$io_dev$portal_api_grpc_common_common_pb.ObjectMeta, 1));
};


/** @param {?proto.common.portal.gloo.solo.io.ObjectMeta|undefined} value */
proto.app.portal.gloo.solo.io.EnvironmentPlans.prototype.setMetadata = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


proto.app.portal.gloo.solo.io.EnvironmentPlans.prototype.clearMetadata = function() {
  this.setMetadata(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.app.portal.gloo.solo.io.EnvironmentPlans.prototype.hasMetadata = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string display_name = 2;
 * @return {string}
 */
proto.app.portal.gloo.solo.io.EnvironmentPlans.prototype.getDisplayName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.app.portal.gloo.solo.io.EnvironmentPlans.prototype.setDisplayName = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated PlanSummary plans = 3;
 * @return {!Array<!proto.app.portal.gloo.solo.io.PlanSummary>}
 */
proto.app.portal.gloo.solo.io.EnvironmentPlans.prototype.getPlansList = function() {
  return /** @type{!Array<!proto.app.portal.gloo.solo.io.PlanSummary>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.app.portal.gloo.solo.io.PlanSummary, 3));
};


/** @param {!Array<!proto.app.portal.gloo.solo.io.PlanSummary>} value */
proto.app.portal.gloo.solo.io.EnvironmentPlans.prototype.setPlansList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.app.portal.gloo.solo.io.PlanSummary=} opt_value
 * @param {number=} opt_index
 * @return {!proto.app.portal.gloo.solo.io.PlanSummary}
 */
proto.app.portal.gloo.solo.io.EnvironmentPlans.prototype.addPlans = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.app.portal.gloo.solo.io.PlanSummary, opt_index);
};


proto.app.portal.gloo.solo.io.EnvironmentPlans.prototype.clearPlansList = function() {
  this.setPlansList([]);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.app.portal.gloo.solo.io.PlanSummary = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.app.portal.gloo.solo.io.PlanSummary.repeatedFields_, null);
};
goog.inherits(proto.app.portal.gloo.solo.io.PlanSummary, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.app.portal.gloo.solo.io.PlanSummary.displayName = 'proto.app.portal.gloo.solo.io.PlanSummary';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.app.portal.gloo.solo.io.PlanSummary.repeatedFields_ = [5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.app.portal.gloo.solo.io.PlanSummary.prototype.toObject = function(opt_includeInstance) {
  return proto.app.portal.gloo.solo.io.PlanSummary.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.app.portal.gloo.solo.io.PlanSummary} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.app.portal.gloo.solo.io.PlanSummary.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    displayName: jspb.Message.getFieldWithDefault(msg, 2, ""),
    requestsPerUnit: jspb.Message.getFieldWithDefault(msg, 3, 0),
    unit: jspb.Message.getFieldWithDefault(msg, 4, ""),
    apiKeysList: jspb.Message.toObjectList(msg.getApiKeysList(),
    proto.app.portal.gloo.solo.io.PlanKey.toObject, includeInstance),
    authPolicyType: jspb.Message.getFieldWithDefault(msg, 6, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.app.portal.gloo.solo.io.PlanSummary}
 */
proto.app.portal.gloo.solo.io.PlanSummary.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.app.portal.gloo.solo.io.PlanSummary;
  return proto.app.portal.gloo.solo.io.PlanSummary.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.app.portal.gloo.solo.io.PlanSummary} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.app.portal.gloo.solo.io.PlanSummary}
 */
proto.app.portal.gloo.solo.io.PlanSummary.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDisplayName(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setRequestsPerUnit(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setUnit(value);
      break;
    case 5:
      var value = new proto.app.portal.gloo.solo.io.PlanKey;
      reader.readMessage(value,proto.app.portal.gloo.solo.io.PlanKey.deserializeBinaryFromReader);
      msg.addApiKeys(value);
      break;
    case 6:
      var value = /** @type {!proto.app.portal.gloo.solo.io.PlanSummary.AuthPolicyType} */ (reader.readEnum());
      msg.setAuthPolicyType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.app.portal.gloo.solo.io.PlanSummary.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.app.portal.gloo.solo.io.PlanSummary.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.app.portal.gloo.solo.io.PlanSummary} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.app.portal.gloo.solo.io.PlanSummary.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDisplayName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getRequestsPerUnit();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getUnit();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getApiKeysList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      proto.app.portal.gloo.solo.io.PlanKey.serializeBinaryToWriter
    );
  }
  f = message.getAuthPolicyType();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.app.portal.gloo.solo.io.PlanSummary.AuthPolicyType = {
  UNAUTHORIZED: 0,
  API_KEY: 1,
  OAUTH: 2
};

/**
 * optional string name = 1;
 * @return {string}
 */
proto.app.portal.gloo.solo.io.PlanSummary.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.app.portal.gloo.solo.io.PlanSummary.prototype.setName = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string display_name = 2;
 * @return {string}
 */
proto.app.portal.gloo.solo.io.PlanSummary.prototype.getDisplayName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.app.portal.gloo.solo.io.PlanSummary.prototype.setDisplayName = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional uint32 requests_per_unit = 3;
 * @return {number}
 */
proto.app.portal.gloo.solo.io.PlanSummary.prototype.getRequestsPerUnit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.app.portal.gloo.solo.io.PlanSummary.prototype.setRequestsPerUnit = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string unit = 4;
 * @return {string}
 */
proto.app.portal.gloo.solo.io.PlanSummary.prototype.getUnit = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.app.portal.gloo.solo.io.PlanSummary.prototype.setUnit = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * repeated PlanKey api_keys = 5;
 * @return {!Array<!proto.app.portal.gloo.solo.io.PlanKey>}
 */
proto.app.portal.gloo.solo.io.PlanSummary.prototype.getApiKeysList = function() {
  return /** @type{!Array<!proto.app.portal.gloo.solo.io.PlanKey>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.app.portal.gloo.solo.io.PlanKey, 5));
};


/** @param {!Array<!proto.app.portal.gloo.solo.io.PlanKey>} value */
proto.app.portal.gloo.solo.io.PlanSummary.prototype.setApiKeysList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.app.portal.gloo.solo.io.PlanKey=} opt_value
 * @param {number=} opt_index
 * @return {!proto.app.portal.gloo.solo.io.PlanKey}
 */
proto.app.portal.gloo.solo.io.PlanSummary.prototype.addApiKeys = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.app.portal.gloo.solo.io.PlanKey, opt_index);
};


proto.app.portal.gloo.solo.io.PlanSummary.prototype.clearApiKeysList = function() {
  this.setApiKeysList([]);
};


/**
 * optional AuthPolicyType auth_policy_type = 6;
 * @return {!proto.app.portal.gloo.solo.io.PlanSummary.AuthPolicyType}
 */
proto.app.portal.gloo.solo.io.PlanSummary.prototype.getAuthPolicyType = function() {
  return /** @type {!proto.app.portal.gloo.solo.io.PlanSummary.AuthPolicyType} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/** @param {!proto.app.portal.gloo.solo.io.PlanSummary.AuthPolicyType} value */
proto.app.portal.gloo.solo.io.PlanSummary.prototype.setAuthPolicyType = function(value) {
  jspb.Message.setProto3EnumField(this, 6, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.app.portal.gloo.solo.io.PlanKey = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.app.portal.gloo.solo.io.PlanKey, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.app.portal.gloo.solo.io.PlanKey.displayName = 'proto.app.portal.gloo.solo.io.PlanKey';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.app.portal.gloo.solo.io.PlanKey.prototype.toObject = function(opt_includeInstance) {
  return proto.app.portal.gloo.solo.io.PlanKey.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.app.portal.gloo.solo.io.PlanKey} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.app.portal.gloo.solo.io.PlanKey.toObject = function(includeInstance, msg) {
  var f, obj = {
    metadata: (f = msg.getMetadata()) && github_com_solo$io_dev$portal_api_grpc_common_common_pb.ObjectMeta.toObject(includeInstance, f),
    key: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.app.portal.gloo.solo.io.PlanKey}
 */
proto.app.portal.gloo.solo.io.PlanKey.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.app.portal.gloo.solo.io.PlanKey;
  return proto.app.portal.gloo.solo.io.PlanKey.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.app.portal.gloo.solo.io.PlanKey} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.app.portal.gloo.solo.io.PlanKey}
 */
proto.app.portal.gloo.solo.io.PlanKey.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new github_com_solo$io_dev$portal_api_grpc_common_common_pb.ObjectMeta;
      reader.readMessage(value,github_com_solo$io_dev$portal_api_grpc_common_common_pb.ObjectMeta.deserializeBinaryFromReader);
      msg.setMetadata(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setKey(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.app.portal.gloo.solo.io.PlanKey.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.app.portal.gloo.solo.io.PlanKey.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.app.portal.gloo.solo.io.PlanKey} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.app.portal.gloo.solo.io.PlanKey.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMetadata();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      github_com_solo$io_dev$portal_api_grpc_common_common_pb.ObjectMeta.serializeBinaryToWriter
    );
  }
  f = message.getKey();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional common.portal.gloo.solo.io.ObjectMeta metadata = 1;
 * @return {?proto.common.portal.gloo.solo.io.ObjectMeta}
 */
proto.app.portal.gloo.solo.io.PlanKey.prototype.getMetadata = function() {
  return /** @type{?proto.common.portal.gloo.solo.io.ObjectMeta} */ (
    jspb.Message.getWrapperField(this, github_com_solo$io_dev$portal_api_grpc_common_common_pb.ObjectMeta, 1));
};


/** @param {?proto.common.portal.gloo.solo.io.ObjectMeta|undefined} value */
proto.app.portal.gloo.solo.io.PlanKey.prototype.setMetadata = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


proto.app.portal.gloo.solo.io.PlanKey.prototype.clearMetadata = function() {
  this.setMetadata(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.app.portal.gloo.solo.io.PlanKey.prototype.hasMetadata = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string key = 2;
 * @return {string}
 */
proto.app.portal.gloo.solo.io.PlanKey.prototype.getKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.app.portal.gloo.solo.io.PlanKey.prototype.setKey = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.app.portal.gloo.solo.io.AddAPIKeyRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.app.portal.gloo.solo.io.AddAPIKeyRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.app.portal.gloo.solo.io.AddAPIKeyRequest.displayName = 'proto.app.portal.gloo.solo.io.AddAPIKeyRequest';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.app.portal.gloo.solo.io.AddAPIKeyRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.app.portal.gloo.solo.io.AddAPIKeyRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.app.portal.gloo.solo.io.AddAPIKeyRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.app.portal.gloo.solo.io.AddAPIKeyRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    apiProductRef: (f = msg.getApiProductRef()) && github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.ObjectRef.toObject(includeInstance, f),
    environmentRef: (f = msg.getEnvironmentRef()) && github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.ObjectRef.toObject(includeInstance, f),
    usagePlanName: jspb.Message.getFieldWithDefault(msg, 3, ""),
    customStringDataMap: (f = msg.getCustomStringDataMap()) ? f.toObject(includeInstance, undefined) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.app.portal.gloo.solo.io.AddAPIKeyRequest}
 */
proto.app.portal.gloo.solo.io.AddAPIKeyRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.app.portal.gloo.solo.io.AddAPIKeyRequest;
  return proto.app.portal.gloo.solo.io.AddAPIKeyRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.app.portal.gloo.solo.io.AddAPIKeyRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.app.portal.gloo.solo.io.AddAPIKeyRequest}
 */
proto.app.portal.gloo.solo.io.AddAPIKeyRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.ObjectRef;
      reader.readMessage(value,github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.ObjectRef.deserializeBinaryFromReader);
      msg.setApiProductRef(value);
      break;
    case 2:
      var value = new github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.ObjectRef;
      reader.readMessage(value,github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.ObjectRef.deserializeBinaryFromReader);
      msg.setEnvironmentRef(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setUsagePlanName(value);
      break;
    case 4:
      var value = msg.getCustomStringDataMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "");
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.app.portal.gloo.solo.io.AddAPIKeyRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.app.portal.gloo.solo.io.AddAPIKeyRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.app.portal.gloo.solo.io.AddAPIKeyRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.app.portal.gloo.solo.io.AddAPIKeyRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getApiProductRef();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.ObjectRef.serializeBinaryToWriter
    );
  }
  f = message.getEnvironmentRef();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.ObjectRef.serializeBinaryToWriter
    );
  }
  f = message.getUsagePlanName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getCustomStringDataMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(4, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
};


/**
 * optional common.portal.gloo.solo.io.ObjectRef api_product_ref = 1;
 * @return {?proto.common.portal.gloo.solo.io.ObjectRef}
 */
proto.app.portal.gloo.solo.io.AddAPIKeyRequest.prototype.getApiProductRef = function() {
  return /** @type{?proto.common.portal.gloo.solo.io.ObjectRef} */ (
    jspb.Message.getWrapperField(this, github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.ObjectRef, 1));
};


/** @param {?proto.common.portal.gloo.solo.io.ObjectRef|undefined} value */
proto.app.portal.gloo.solo.io.AddAPIKeyRequest.prototype.setApiProductRef = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


proto.app.portal.gloo.solo.io.AddAPIKeyRequest.prototype.clearApiProductRef = function() {
  this.setApiProductRef(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.app.portal.gloo.solo.io.AddAPIKeyRequest.prototype.hasApiProductRef = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional common.portal.gloo.solo.io.ObjectRef environment_ref = 2;
 * @return {?proto.common.portal.gloo.solo.io.ObjectRef}
 */
proto.app.portal.gloo.solo.io.AddAPIKeyRequest.prototype.getEnvironmentRef = function() {
  return /** @type{?proto.common.portal.gloo.solo.io.ObjectRef} */ (
    jspb.Message.getWrapperField(this, github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.ObjectRef, 2));
};


/** @param {?proto.common.portal.gloo.solo.io.ObjectRef|undefined} value */
proto.app.portal.gloo.solo.io.AddAPIKeyRequest.prototype.setEnvironmentRef = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


proto.app.portal.gloo.solo.io.AddAPIKeyRequest.prototype.clearEnvironmentRef = function() {
  this.setEnvironmentRef(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.app.portal.gloo.solo.io.AddAPIKeyRequest.prototype.hasEnvironmentRef = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string usage_plan_name = 3;
 * @return {string}
 */
proto.app.portal.gloo.solo.io.AddAPIKeyRequest.prototype.getUsagePlanName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.app.portal.gloo.solo.io.AddAPIKeyRequest.prototype.setUsagePlanName = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * map<string, string> custom_string_data = 4;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.app.portal.gloo.solo.io.AddAPIKeyRequest.prototype.getCustomStringDataMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 4, opt_noLazyCreate,
      null));
};


proto.app.portal.gloo.solo.io.AddAPIKeyRequest.prototype.clearCustomStringDataMap = function() {
  this.getCustomStringDataMap().clear();
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.app.portal.gloo.solo.io.AddAPIKeyResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.app.portal.gloo.solo.io.AddAPIKeyResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.app.portal.gloo.solo.io.AddAPIKeyResponse.displayName = 'proto.app.portal.gloo.solo.io.AddAPIKeyResponse';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.app.portal.gloo.solo.io.AddAPIKeyResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.app.portal.gloo.solo.io.AddAPIKeyResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.app.portal.gloo.solo.io.AddAPIKeyResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.app.portal.gloo.solo.io.AddAPIKeyResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    metadata: (f = msg.getMetadata()) && github_com_solo$io_dev$portal_api_grpc_common_common_pb.ObjectMeta.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.app.portal.gloo.solo.io.AddAPIKeyResponse}
 */
proto.app.portal.gloo.solo.io.AddAPIKeyResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.app.portal.gloo.solo.io.AddAPIKeyResponse;
  return proto.app.portal.gloo.solo.io.AddAPIKeyResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.app.portal.gloo.solo.io.AddAPIKeyResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.app.portal.gloo.solo.io.AddAPIKeyResponse}
 */
proto.app.portal.gloo.solo.io.AddAPIKeyResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new github_com_solo$io_dev$portal_api_grpc_common_common_pb.ObjectMeta;
      reader.readMessage(value,github_com_solo$io_dev$portal_api_grpc_common_common_pb.ObjectMeta.deserializeBinaryFromReader);
      msg.setMetadata(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.app.portal.gloo.solo.io.AddAPIKeyResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.app.portal.gloo.solo.io.AddAPIKeyResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.app.portal.gloo.solo.io.AddAPIKeyResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.app.portal.gloo.solo.io.AddAPIKeyResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMetadata();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      github_com_solo$io_dev$portal_api_grpc_common_common_pb.ObjectMeta.serializeBinaryToWriter
    );
  }
};


/**
 * optional common.portal.gloo.solo.io.ObjectMeta metadata = 1;
 * @return {?proto.common.portal.gloo.solo.io.ObjectMeta}
 */
proto.app.portal.gloo.solo.io.AddAPIKeyResponse.prototype.getMetadata = function() {
  return /** @type{?proto.common.portal.gloo.solo.io.ObjectMeta} */ (
    jspb.Message.getWrapperField(this, github_com_solo$io_dev$portal_api_grpc_common_common_pb.ObjectMeta, 1));
};


/** @param {?proto.common.portal.gloo.solo.io.ObjectMeta|undefined} value */
proto.app.portal.gloo.solo.io.AddAPIKeyResponse.prototype.setMetadata = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


proto.app.portal.gloo.solo.io.AddAPIKeyResponse.prototype.clearMetadata = function() {
  this.setMetadata(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.app.portal.gloo.solo.io.AddAPIKeyResponse.prototype.hasMetadata = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.app.portal.gloo.solo.io.GetPortalSummaryResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.app.portal.gloo.solo.io.GetPortalSummaryResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.app.portal.gloo.solo.io.GetPortalSummaryResponse.displayName = 'proto.app.portal.gloo.solo.io.GetPortalSummaryResponse';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.app.portal.gloo.solo.io.GetPortalSummaryResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.app.portal.gloo.solo.io.GetPortalSummaryResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.app.portal.gloo.solo.io.GetPortalSummaryResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.app.portal.gloo.solo.io.GetPortalSummaryResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    displayName: jspb.Message.getFieldWithDefault(msg, 1, ""),
    description: jspb.Message.getFieldWithDefault(msg, 2, ""),
    oidcLoginUrl: jspb.Message.getFieldWithDefault(msg, 3, ""),
    basicAuthLoginEnabled: jspb.Message.getFieldWithDefault(msg, 4, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.app.portal.gloo.solo.io.GetPortalSummaryResponse}
 */
proto.app.portal.gloo.solo.io.GetPortalSummaryResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.app.portal.gloo.solo.io.GetPortalSummaryResponse;
  return proto.app.portal.gloo.solo.io.GetPortalSummaryResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.app.portal.gloo.solo.io.GetPortalSummaryResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.app.portal.gloo.solo.io.GetPortalSummaryResponse}
 */
proto.app.portal.gloo.solo.io.GetPortalSummaryResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDisplayName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setOidcLoginUrl(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setBasicAuthLoginEnabled(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.app.portal.gloo.solo.io.GetPortalSummaryResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.app.portal.gloo.solo.io.GetPortalSummaryResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.app.portal.gloo.solo.io.GetPortalSummaryResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.app.portal.gloo.solo.io.GetPortalSummaryResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDisplayName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getOidcLoginUrl();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getBasicAuthLoginEnabled();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
};


/**
 * optional string display_name = 1;
 * @return {string}
 */
proto.app.portal.gloo.solo.io.GetPortalSummaryResponse.prototype.getDisplayName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.app.portal.gloo.solo.io.GetPortalSummaryResponse.prototype.setDisplayName = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string description = 2;
 * @return {string}
 */
proto.app.portal.gloo.solo.io.GetPortalSummaryResponse.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.app.portal.gloo.solo.io.GetPortalSummaryResponse.prototype.setDescription = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string oidc_login_url = 3;
 * @return {string}
 */
proto.app.portal.gloo.solo.io.GetPortalSummaryResponse.prototype.getOidcLoginUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.app.portal.gloo.solo.io.GetPortalSummaryResponse.prototype.setOidcLoginUrl = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional bool basic_auth_login_enabled = 4;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.app.portal.gloo.solo.io.GetPortalSummaryResponse.prototype.getBasicAuthLoginEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 4, false));
};


/** @param {boolean} value */
proto.app.portal.gloo.solo.io.GetPortalSummaryResponse.prototype.setBasicAuthLoginEnabled = function(value) {
  jspb.Message.setProto3BooleanField(this, 4, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.app.portal.gloo.solo.io.GetCustomStylingResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.app.portal.gloo.solo.io.GetCustomStylingResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.app.portal.gloo.solo.io.GetCustomStylingResponse.displayName = 'proto.app.portal.gloo.solo.io.GetCustomStylingResponse';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.app.portal.gloo.solo.io.GetCustomStylingResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.app.portal.gloo.solo.io.GetCustomStylingResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.app.portal.gloo.solo.io.GetCustomStylingResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.app.portal.gloo.solo.io.GetCustomStylingResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    customStyling: (f = msg.getCustomStyling()) && github_com_solo$io_dev$portal_api_dev$portal_v1beta1_portal_pb.CustomStyling.toObject(includeInstance, f),
    faviconUrl: jspb.Message.getFieldWithDefault(msg, 2, ""),
    logoUrl: jspb.Message.getFieldWithDefault(msg, 3, ""),
    bannerUrl: jspb.Message.getFieldWithDefault(msg, 4, ""),
    customCss: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.app.portal.gloo.solo.io.GetCustomStylingResponse}
 */
proto.app.portal.gloo.solo.io.GetCustomStylingResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.app.portal.gloo.solo.io.GetCustomStylingResponse;
  return proto.app.portal.gloo.solo.io.GetCustomStylingResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.app.portal.gloo.solo.io.GetCustomStylingResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.app.portal.gloo.solo.io.GetCustomStylingResponse}
 */
proto.app.portal.gloo.solo.io.GetCustomStylingResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new github_com_solo$io_dev$portal_api_dev$portal_v1beta1_portal_pb.CustomStyling;
      reader.readMessage(value,github_com_solo$io_dev$portal_api_dev$portal_v1beta1_portal_pb.CustomStyling.deserializeBinaryFromReader);
      msg.setCustomStyling(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFaviconUrl(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setLogoUrl(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setBannerUrl(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setCustomCss(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.app.portal.gloo.solo.io.GetCustomStylingResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.app.portal.gloo.solo.io.GetCustomStylingResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.app.portal.gloo.solo.io.GetCustomStylingResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.app.portal.gloo.solo.io.GetCustomStylingResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCustomStyling();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      github_com_solo$io_dev$portal_api_dev$portal_v1beta1_portal_pb.CustomStyling.serializeBinaryToWriter
    );
  }
  f = message.getFaviconUrl();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getLogoUrl();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getBannerUrl();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getCustomCss();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional portal.gloo.solo.io.CustomStyling custom_styling = 1;
 * @return {?proto.portal.gloo.solo.io.CustomStyling}
 */
proto.app.portal.gloo.solo.io.GetCustomStylingResponse.prototype.getCustomStyling = function() {
  return /** @type{?proto.portal.gloo.solo.io.CustomStyling} */ (
    jspb.Message.getWrapperField(this, github_com_solo$io_dev$portal_api_dev$portal_v1beta1_portal_pb.CustomStyling, 1));
};


/** @param {?proto.portal.gloo.solo.io.CustomStyling|undefined} value */
proto.app.portal.gloo.solo.io.GetCustomStylingResponse.prototype.setCustomStyling = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


proto.app.portal.gloo.solo.io.GetCustomStylingResponse.prototype.clearCustomStyling = function() {
  this.setCustomStyling(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.app.portal.gloo.solo.io.GetCustomStylingResponse.prototype.hasCustomStyling = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string favicon_url = 2;
 * @return {string}
 */
proto.app.portal.gloo.solo.io.GetCustomStylingResponse.prototype.getFaviconUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.app.portal.gloo.solo.io.GetCustomStylingResponse.prototype.setFaviconUrl = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string logo_url = 3;
 * @return {string}
 */
proto.app.portal.gloo.solo.io.GetCustomStylingResponse.prototype.getLogoUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.app.portal.gloo.solo.io.GetCustomStylingResponse.prototype.setLogoUrl = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string banner_url = 4;
 * @return {string}
 */
proto.app.portal.gloo.solo.io.GetCustomStylingResponse.prototype.getBannerUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.app.portal.gloo.solo.io.GetCustomStylingResponse.prototype.setBannerUrl = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string custom_css = 5;
 * @return {string}
 */
proto.app.portal.gloo.solo.io.GetCustomStylingResponse.prototype.getCustomCss = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/** @param {string} value */
proto.app.portal.gloo.solo.io.GetCustomStylingResponse.prototype.setCustomCss = function(value) {
  jspb.Message.setProto3StringField(this, 5, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.app.portal.gloo.solo.io.GetPageExtensionsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.app.portal.gloo.solo.io.GetPageExtensionsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.app.portal.gloo.solo.io.GetPageExtensionsResponse.displayName = 'proto.app.portal.gloo.solo.io.GetPageExtensionsResponse';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.app.portal.gloo.solo.io.GetPageExtensionsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.app.portal.gloo.solo.io.GetPageExtensionsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.app.portal.gloo.solo.io.GetPageExtensionsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.app.portal.gloo.solo.io.GetPageExtensionsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    pageExtensionsMap: (f = msg.getPageExtensionsMap()) ? f.toObject(includeInstance, undefined) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.app.portal.gloo.solo.io.GetPageExtensionsResponse}
 */
proto.app.portal.gloo.solo.io.GetPageExtensionsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.app.portal.gloo.solo.io.GetPageExtensionsResponse;
  return proto.app.portal.gloo.solo.io.GetPageExtensionsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.app.portal.gloo.solo.io.GetPageExtensionsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.app.portal.gloo.solo.io.GetPageExtensionsResponse}
 */
proto.app.portal.gloo.solo.io.GetPageExtensionsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = msg.getPageExtensionsMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "");
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.app.portal.gloo.solo.io.GetPageExtensionsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.app.portal.gloo.solo.io.GetPageExtensionsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.app.portal.gloo.solo.io.GetPageExtensionsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.app.portal.gloo.solo.io.GetPageExtensionsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPageExtensionsMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(1, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
};


/**
 * map<string, string> page_extensions = 1;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.app.portal.gloo.solo.io.GetPageExtensionsResponse.prototype.getPageExtensionsMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 1, opt_noLazyCreate,
      null));
};


proto.app.portal.gloo.solo.io.GetPageExtensionsResponse.prototype.clearPageExtensionsMap = function() {
  this.getPageExtensionsMap().clear();
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.app.portal.gloo.solo.io.GetStaticPagesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.app.portal.gloo.solo.io.GetStaticPagesResponse.repeatedFields_, null);
};
goog.inherits(proto.app.portal.gloo.solo.io.GetStaticPagesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.app.portal.gloo.solo.io.GetStaticPagesResponse.displayName = 'proto.app.portal.gloo.solo.io.GetStaticPagesResponse';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.app.portal.gloo.solo.io.GetStaticPagesResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.app.portal.gloo.solo.io.GetStaticPagesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.app.portal.gloo.solo.io.GetStaticPagesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.app.portal.gloo.solo.io.GetStaticPagesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.app.portal.gloo.solo.io.GetStaticPagesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    staticPagesList: jspb.Message.toObjectList(msg.getStaticPagesList(),
    github_com_solo$io_dev$portal_api_dev$portal_v1beta1_portal_pb.PageSpec.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.app.portal.gloo.solo.io.GetStaticPagesResponse}
 */
proto.app.portal.gloo.solo.io.GetStaticPagesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.app.portal.gloo.solo.io.GetStaticPagesResponse;
  return proto.app.portal.gloo.solo.io.GetStaticPagesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.app.portal.gloo.solo.io.GetStaticPagesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.app.portal.gloo.solo.io.GetStaticPagesResponse}
 */
proto.app.portal.gloo.solo.io.GetStaticPagesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new github_com_solo$io_dev$portal_api_dev$portal_v1beta1_portal_pb.PageSpec;
      reader.readMessage(value,github_com_solo$io_dev$portal_api_dev$portal_v1beta1_portal_pb.PageSpec.deserializeBinaryFromReader);
      msg.addStaticPages(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.app.portal.gloo.solo.io.GetStaticPagesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.app.portal.gloo.solo.io.GetStaticPagesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.app.portal.gloo.solo.io.GetStaticPagesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.app.portal.gloo.solo.io.GetStaticPagesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStaticPagesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      github_com_solo$io_dev$portal_api_dev$portal_v1beta1_portal_pb.PageSpec.serializeBinaryToWriter
    );
  }
};


/**
 * repeated portal.gloo.solo.io.PageSpec static_pages = 1;
 * @return {!Array<!proto.portal.gloo.solo.io.PageSpec>}
 */
proto.app.portal.gloo.solo.io.GetStaticPagesResponse.prototype.getStaticPagesList = function() {
  return /** @type{!Array<!proto.portal.gloo.solo.io.PageSpec>} */ (
    jspb.Message.getRepeatedWrapperField(this, github_com_solo$io_dev$portal_api_dev$portal_v1beta1_portal_pb.PageSpec, 1));
};


/** @param {!Array<!proto.portal.gloo.solo.io.PageSpec>} value */
proto.app.portal.gloo.solo.io.GetStaticPagesResponse.prototype.setStaticPagesList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.portal.gloo.solo.io.PageSpec=} opt_value
 * @param {number=} opt_index
 * @return {!proto.portal.gloo.solo.io.PageSpec}
 */
proto.app.portal.gloo.solo.io.GetStaticPagesResponse.prototype.addStaticPages = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.portal.gloo.solo.io.PageSpec, opt_index);
};


proto.app.portal.gloo.solo.io.GetStaticPagesResponse.prototype.clearStaticPagesList = function() {
  this.setStaticPagesList([]);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.app.portal.gloo.solo.io.GetDynamicPagesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.app.portal.gloo.solo.io.GetDynamicPagesResponse.repeatedFields_, null);
};
goog.inherits(proto.app.portal.gloo.solo.io.GetDynamicPagesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.app.portal.gloo.solo.io.GetDynamicPagesResponse.displayName = 'proto.app.portal.gloo.solo.io.GetDynamicPagesResponse';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.app.portal.gloo.solo.io.GetDynamicPagesResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.app.portal.gloo.solo.io.GetDynamicPagesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.app.portal.gloo.solo.io.GetDynamicPagesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.app.portal.gloo.solo.io.GetDynamicPagesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.app.portal.gloo.solo.io.GetDynamicPagesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    dynamicPagesList: jspb.Message.toObjectList(msg.getDynamicPagesList(),
    proto.app.portal.gloo.solo.io.DynamicPage.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.app.portal.gloo.solo.io.GetDynamicPagesResponse}
 */
proto.app.portal.gloo.solo.io.GetDynamicPagesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.app.portal.gloo.solo.io.GetDynamicPagesResponse;
  return proto.app.portal.gloo.solo.io.GetDynamicPagesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.app.portal.gloo.solo.io.GetDynamicPagesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.app.portal.gloo.solo.io.GetDynamicPagesResponse}
 */
proto.app.portal.gloo.solo.io.GetDynamicPagesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.app.portal.gloo.solo.io.DynamicPage;
      reader.readMessage(value,proto.app.portal.gloo.solo.io.DynamicPage.deserializeBinaryFromReader);
      msg.addDynamicPages(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.app.portal.gloo.solo.io.GetDynamicPagesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.app.portal.gloo.solo.io.GetDynamicPagesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.app.portal.gloo.solo.io.GetDynamicPagesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.app.portal.gloo.solo.io.GetDynamicPagesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDynamicPagesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.app.portal.gloo.solo.io.DynamicPage.serializeBinaryToWriter
    );
  }
};


/**
 * repeated DynamicPage dynamic_pages = 1;
 * @return {!Array<!proto.app.portal.gloo.solo.io.DynamicPage>}
 */
proto.app.portal.gloo.solo.io.GetDynamicPagesResponse.prototype.getDynamicPagesList = function() {
  return /** @type{!Array<!proto.app.portal.gloo.solo.io.DynamicPage>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.app.portal.gloo.solo.io.DynamicPage, 1));
};


/** @param {!Array<!proto.app.portal.gloo.solo.io.DynamicPage>} value */
proto.app.portal.gloo.solo.io.GetDynamicPagesResponse.prototype.setDynamicPagesList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.app.portal.gloo.solo.io.DynamicPage=} opt_value
 * @param {number=} opt_index
 * @return {!proto.app.portal.gloo.solo.io.DynamicPage}
 */
proto.app.portal.gloo.solo.io.GetDynamicPagesResponse.prototype.addDynamicPages = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.app.portal.gloo.solo.io.DynamicPage, opt_index);
};


proto.app.portal.gloo.solo.io.GetDynamicPagesResponse.prototype.clearDynamicPagesList = function() {
  this.setDynamicPagesList([]);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.app.portal.gloo.solo.io.DynamicPage = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.app.portal.gloo.solo.io.DynamicPage, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.app.portal.gloo.solo.io.DynamicPage.displayName = 'proto.app.portal.gloo.solo.io.DynamicPage';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.app.portal.gloo.solo.io.DynamicPage.prototype.toObject = function(opt_includeInstance) {
  return proto.app.portal.gloo.solo.io.DynamicPage.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.app.portal.gloo.solo.io.DynamicPage} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.app.portal.gloo.solo.io.DynamicPage.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    description: jspb.Message.getFieldWithDefault(msg, 2, ""),
    path: jspb.Message.getFieldWithDefault(msg, 3, ""),
    navigationLinkName: jspb.Message.getFieldWithDefault(msg, 4, ""),
    displayOnHomepage: jspb.Message.getFieldWithDefault(msg, 6, false),
    url: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.app.portal.gloo.solo.io.DynamicPage}
 */
proto.app.portal.gloo.solo.io.DynamicPage.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.app.portal.gloo.solo.io.DynamicPage;
  return proto.app.portal.gloo.solo.io.DynamicPage.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.app.portal.gloo.solo.io.DynamicPage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.app.portal.gloo.solo.io.DynamicPage}
 */
proto.app.portal.gloo.solo.io.DynamicPage.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPath(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setNavigationLinkName(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDisplayOnHomepage(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setUrl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.app.portal.gloo.solo.io.DynamicPage.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.app.portal.gloo.solo.io.DynamicPage.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.app.portal.gloo.solo.io.DynamicPage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.app.portal.gloo.solo.io.DynamicPage.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPath();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getNavigationLinkName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getDisplayOnHomepage();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getUrl();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.app.portal.gloo.solo.io.DynamicPage.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.app.portal.gloo.solo.io.DynamicPage.prototype.setName = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string description = 2;
 * @return {string}
 */
proto.app.portal.gloo.solo.io.DynamicPage.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.app.portal.gloo.solo.io.DynamicPage.prototype.setDescription = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string path = 3;
 * @return {string}
 */
proto.app.portal.gloo.solo.io.DynamicPage.prototype.getPath = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.app.portal.gloo.solo.io.DynamicPage.prototype.setPath = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string navigation_link_name = 4;
 * @return {string}
 */
proto.app.portal.gloo.solo.io.DynamicPage.prototype.getNavigationLinkName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.app.portal.gloo.solo.io.DynamicPage.prototype.setNavigationLinkName = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional bool display_on_homepage = 6;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.app.portal.gloo.solo.io.DynamicPage.prototype.getDisplayOnHomepage = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 6, false));
};


/** @param {boolean} value */
proto.app.portal.gloo.solo.io.DynamicPage.prototype.setDisplayOnHomepage = function(value) {
  jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * optional string url = 5;
 * @return {string}
 */
proto.app.portal.gloo.solo.io.DynamicPage.prototype.getUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/** @param {string} value */
proto.app.portal.gloo.solo.io.DynamicPage.prototype.setUrl = function(value) {
  jspb.Message.setProto3StringField(this, 5, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.app.portal.gloo.solo.io.GRPCInvokeRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.app.portal.gloo.solo.io.GRPCInvokeRequest.oneofGroups_);
};
goog.inherits(proto.app.portal.gloo.solo.io.GRPCInvokeRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.app.portal.gloo.solo.io.GRPCInvokeRequest.displayName = 'proto.app.portal.gloo.solo.io.GRPCInvokeRequest';
}
/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.app.portal.gloo.solo.io.GRPCInvokeRequest.oneofGroups_ = [[8,9]];

/**
 * @enum {number}
 */
proto.app.portal.gloo.solo.io.GRPCInvokeRequest.AuthInfoCase = {
  AUTH_INFO_NOT_SET: 0,
  API_KEY: 8,
  OAUTH_ACCESS_TOKEN: 9
};

/**
 * @return {proto.app.portal.gloo.solo.io.GRPCInvokeRequest.AuthInfoCase}
 */
proto.app.portal.gloo.solo.io.GRPCInvokeRequest.prototype.getAuthInfoCase = function() {
  return /** @type {proto.app.portal.gloo.solo.io.GRPCInvokeRequest.AuthInfoCase} */(jspb.Message.computeOneofCase(this, proto.app.portal.gloo.solo.io.GRPCInvokeRequest.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.app.portal.gloo.solo.io.GRPCInvokeRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.app.portal.gloo.solo.io.GRPCInvokeRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.app.portal.gloo.solo.io.GRPCInvokeRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.app.portal.gloo.solo.io.GRPCInvokeRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    apiProductRef: (f = msg.getApiProductRef()) && github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.ObjectRef.toObject(includeInstance, f),
    environmentRef: (f = msg.getEnvironmentRef()) && github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.ObjectRef.toObject(includeInstance, f),
    version: jspb.Message.getFieldWithDefault(msg, 3, ""),
    serviceDomain: jspb.Message.getFieldWithDefault(msg, 4, ""),
    serviceName: jspb.Message.getFieldWithDefault(msg, 5, ""),
    methodName: jspb.Message.getFieldWithDefault(msg, 6, ""),
    argumentJson: jspb.Message.getFieldWithDefault(msg, 7, ""),
    apiKey: jspb.Message.getFieldWithDefault(msg, 8, ""),
    oauthAccessToken: jspb.Message.getFieldWithDefault(msg, 9, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.app.portal.gloo.solo.io.GRPCInvokeRequest}
 */
proto.app.portal.gloo.solo.io.GRPCInvokeRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.app.portal.gloo.solo.io.GRPCInvokeRequest;
  return proto.app.portal.gloo.solo.io.GRPCInvokeRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.app.portal.gloo.solo.io.GRPCInvokeRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.app.portal.gloo.solo.io.GRPCInvokeRequest}
 */
proto.app.portal.gloo.solo.io.GRPCInvokeRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.ObjectRef;
      reader.readMessage(value,github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.ObjectRef.deserializeBinaryFromReader);
      msg.setApiProductRef(value);
      break;
    case 2:
      var value = new github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.ObjectRef;
      reader.readMessage(value,github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.ObjectRef.deserializeBinaryFromReader);
      msg.setEnvironmentRef(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setVersion(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setServiceDomain(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setServiceName(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setMethodName(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setArgumentJson(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setApiKey(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setOauthAccessToken(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.app.portal.gloo.solo.io.GRPCInvokeRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.app.portal.gloo.solo.io.GRPCInvokeRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.app.portal.gloo.solo.io.GRPCInvokeRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.app.portal.gloo.solo.io.GRPCInvokeRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getApiProductRef();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.ObjectRef.serializeBinaryToWriter
    );
  }
  f = message.getEnvironmentRef();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.ObjectRef.serializeBinaryToWriter
    );
  }
  f = message.getVersion();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getServiceDomain();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getServiceName();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getMethodName();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getArgumentJson();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 8));
  if (f != null) {
    writer.writeString(
      8,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 9));
  if (f != null) {
    writer.writeString(
      9,
      f
    );
  }
};


/**
 * optional common.portal.gloo.solo.io.ObjectRef api_product_ref = 1;
 * @return {?proto.common.portal.gloo.solo.io.ObjectRef}
 */
proto.app.portal.gloo.solo.io.GRPCInvokeRequest.prototype.getApiProductRef = function() {
  return /** @type{?proto.common.portal.gloo.solo.io.ObjectRef} */ (
    jspb.Message.getWrapperField(this, github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.ObjectRef, 1));
};


/** @param {?proto.common.portal.gloo.solo.io.ObjectRef|undefined} value */
proto.app.portal.gloo.solo.io.GRPCInvokeRequest.prototype.setApiProductRef = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


proto.app.portal.gloo.solo.io.GRPCInvokeRequest.prototype.clearApiProductRef = function() {
  this.setApiProductRef(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.app.portal.gloo.solo.io.GRPCInvokeRequest.prototype.hasApiProductRef = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional common.portal.gloo.solo.io.ObjectRef environment_ref = 2;
 * @return {?proto.common.portal.gloo.solo.io.ObjectRef}
 */
proto.app.portal.gloo.solo.io.GRPCInvokeRequest.prototype.getEnvironmentRef = function() {
  return /** @type{?proto.common.portal.gloo.solo.io.ObjectRef} */ (
    jspb.Message.getWrapperField(this, github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.ObjectRef, 2));
};


/** @param {?proto.common.portal.gloo.solo.io.ObjectRef|undefined} value */
proto.app.portal.gloo.solo.io.GRPCInvokeRequest.prototype.setEnvironmentRef = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


proto.app.portal.gloo.solo.io.GRPCInvokeRequest.prototype.clearEnvironmentRef = function() {
  this.setEnvironmentRef(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.app.portal.gloo.solo.io.GRPCInvokeRequest.prototype.hasEnvironmentRef = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string version = 3;
 * @return {string}
 */
proto.app.portal.gloo.solo.io.GRPCInvokeRequest.prototype.getVersion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.app.portal.gloo.solo.io.GRPCInvokeRequest.prototype.setVersion = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string service_domain = 4;
 * @return {string}
 */
proto.app.portal.gloo.solo.io.GRPCInvokeRequest.prototype.getServiceDomain = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.app.portal.gloo.solo.io.GRPCInvokeRequest.prototype.setServiceDomain = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string service_name = 5;
 * @return {string}
 */
proto.app.portal.gloo.solo.io.GRPCInvokeRequest.prototype.getServiceName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/** @param {string} value */
proto.app.portal.gloo.solo.io.GRPCInvokeRequest.prototype.setServiceName = function(value) {
  jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string method_name = 6;
 * @return {string}
 */
proto.app.portal.gloo.solo.io.GRPCInvokeRequest.prototype.getMethodName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/** @param {string} value */
proto.app.portal.gloo.solo.io.GRPCInvokeRequest.prototype.setMethodName = function(value) {
  jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string argument_json = 7;
 * @return {string}
 */
proto.app.portal.gloo.solo.io.GRPCInvokeRequest.prototype.getArgumentJson = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/** @param {string} value */
proto.app.portal.gloo.solo.io.GRPCInvokeRequest.prototype.setArgumentJson = function(value) {
  jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string api_key = 8;
 * @return {string}
 */
proto.app.portal.gloo.solo.io.GRPCInvokeRequest.prototype.getApiKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/** @param {string} value */
proto.app.portal.gloo.solo.io.GRPCInvokeRequest.prototype.setApiKey = function(value) {
  jspb.Message.setOneofField(this, 8, proto.app.portal.gloo.solo.io.GRPCInvokeRequest.oneofGroups_[0], value);
};


proto.app.portal.gloo.solo.io.GRPCInvokeRequest.prototype.clearApiKey = function() {
  jspb.Message.setOneofField(this, 8, proto.app.portal.gloo.solo.io.GRPCInvokeRequest.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.app.portal.gloo.solo.io.GRPCInvokeRequest.prototype.hasApiKey = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional string oauth_access_token = 9;
 * @return {string}
 */
proto.app.portal.gloo.solo.io.GRPCInvokeRequest.prototype.getOauthAccessToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/** @param {string} value */
proto.app.portal.gloo.solo.io.GRPCInvokeRequest.prototype.setOauthAccessToken = function(value) {
  jspb.Message.setOneofField(this, 9, proto.app.portal.gloo.solo.io.GRPCInvokeRequest.oneofGroups_[0], value);
};


proto.app.portal.gloo.solo.io.GRPCInvokeRequest.prototype.clearOauthAccessToken = function() {
  jspb.Message.setOneofField(this, 9, proto.app.portal.gloo.solo.io.GRPCInvokeRequest.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.app.portal.gloo.solo.io.GRPCInvokeRequest.prototype.hasOauthAccessToken = function() {
  return jspb.Message.getField(this, 9) != null;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.app.portal.gloo.solo.io.GRPCInvokeResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.app.portal.gloo.solo.io.GRPCInvokeResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.app.portal.gloo.solo.io.GRPCInvokeResponse.displayName = 'proto.app.portal.gloo.solo.io.GRPCInvokeResponse';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.app.portal.gloo.solo.io.GRPCInvokeResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.app.portal.gloo.solo.io.GRPCInvokeResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.app.portal.gloo.solo.io.GRPCInvokeResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.app.portal.gloo.solo.io.GRPCInvokeResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    data: jspb.Message.getFieldWithDefault(msg, 1, ""),
    error: jspb.Message.getFieldWithDefault(msg, 2, ""),
    statusCode: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.app.portal.gloo.solo.io.GRPCInvokeResponse}
 */
proto.app.portal.gloo.solo.io.GRPCInvokeResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.app.portal.gloo.solo.io.GRPCInvokeResponse;
  return proto.app.portal.gloo.solo.io.GRPCInvokeResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.app.portal.gloo.solo.io.GRPCInvokeResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.app.portal.gloo.solo.io.GRPCInvokeResponse}
 */
proto.app.portal.gloo.solo.io.GRPCInvokeResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setData(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setError(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setStatusCode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.app.portal.gloo.solo.io.GRPCInvokeResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.app.portal.gloo.solo.io.GRPCInvokeResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.app.portal.gloo.solo.io.GRPCInvokeResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.app.portal.gloo.solo.io.GRPCInvokeResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getData();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getError();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getStatusCode();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional string data = 1;
 * @return {string}
 */
proto.app.portal.gloo.solo.io.GRPCInvokeResponse.prototype.getData = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.app.portal.gloo.solo.io.GRPCInvokeResponse.prototype.setData = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string error = 2;
 * @return {string}
 */
proto.app.portal.gloo.solo.io.GRPCInvokeResponse.prototype.getError = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.app.portal.gloo.solo.io.GRPCInvokeResponse.prototype.setError = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 status_code = 3;
 * @return {number}
 */
proto.app.portal.gloo.solo.io.GRPCInvokeResponse.prototype.getStatusCode = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.app.portal.gloo.solo.io.GRPCInvokeResponse.prototype.setStatusCode = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


goog.object.extend(exports, proto.app.portal.gloo.solo.io);
